import React, { Fragment, useState, useEffect, useMemo, useRef } from "react";
import ProcessPDFView from "../components/ProcessPDFView";
import Navbar from "../components/Navbar";
import DropDownWithSearch from "../components/DropDownWithSearch";
import { Col, Row } from "react-bootstrap";
import { MdModeEditOutline } from "react-icons/md";
import { BsPlusLg, BsFillPersonFill, BsBagCheckFill } from "react-icons/bs";
import { FaEye, FaUserNurse } from "react-icons/fa";
import { GrMapLocation } from "react-icons/gr";
import { IoMdClose } from "react-icons/io";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import CommanSpinner from "../components/CommanSpinner";
import { useHistory } from "react-router-dom";
import SuccessErrorPopup from "../CommonComponents/SuccessErrorPopup";
import { stateCodes } from "../variable";
import { useCookies } from "react-cookie";
import { sortArrayListAsc } from "../Utils";
import { axiosRequest } from "../axiosConfig";
import { pdfCacheManager } from "../utils/pdfCacheManager";
import { faxCacheManager } from "../utils/faxCacheManager";
import {
  Autocomplete,
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid2,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Popover,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import PdfThumnailView from "../components/PdfThumbnailView";
import Grid from "@mui/material/Grid2";
import ViewPage from "./ViewPage";
import ProcessDocumentTabView from "../components/ProcessDocumentTabView";
import {
  Person as PersonIcon,
  ShoppingBag as BagIcon,
  LocationOn as LocationIcon,
  Visibility as EyeIcon,
  MedicalServices as NurseIcon,
  SaveAlt,
} from "@mui/icons-material";
import {
  Edit as EditIcon,
  Add as AddIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import PatientDialog from "./CreateAndAttachPatientDialog";
import AttachPatientDialog from "./AttachPatientDialog";
import CreateOrderDialog from "./CreateOrderDialog";
import { ReactComponent as ElsaLogo } from "./ElsaLogov2.svg";

import AttachOrderDialog from "./AttachToOrderDialog";

import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import SaveIcon from "@mui/icons-material/Save";
import PDFViewer from "../components/PdfView";
import PdfWithHighlights from "../components/PdfView";
import PdfHighlighter from "../components/PdfView";
import PdfHighlighterZoomable from "../components/PdfView";
import PdfHighlighterPanZoom from "../components/PdfView";
import { Document, Page } from "react-pdf";
import FormFields from "../components/FormFields";
import {
  OrderDetailsSection,
  PatientDetailsSection,
  ProviderDetailsSection,
  TypeSelectionSection,
} from "../components/SummaryFields";
import PDFSplitter from "../components/PDFSplitter";
import ElsaContent from "../components/ElsaContent";
import LoadingSuccessErrorDialog from "../CommonComponents/SuccessErrorPopup";
import { isDemo } from "../App";

const ProcessComponent = (props) => {
  const history = useHistory();
  const [uploadedPdf, setUploadedPdf] = useState("");
  const [uploadFiles, setUploadeFiles] = useState("");
  const outSideRef = useRef(null);
  const [patientDetailpopup, setPatientDetailpopup] = useState(false);
  const [addBtnPopup, setaddBtnPopup] = useState(false);
  const [attachPatientPopup, setattachPatientPopup] = useState(false);
  const [createAttachPatientPopup, setcreateAttachPatientPopup] =
    useState(false);
  const [attachOrderPopup, setattachOrderPopup] = useState(false);
  const [createAttachOrderPopup, setcreateAttachOrderPopup] = useState(false);
  const [currentPage, setCurrentPage] = useState("parent");

  const [patientTypeDropdown, setpatientTypeDropdown] = useState("Existing");
  const [orderTypeDropdown, setorderTypeDropdown] = useState("Existing");
  const [providerTypeDropdown, setproviderTypeDropdown] = useState("Existing");

  const [therapyTypeDropdownList, settherapyTypeDropdownList] = useState([]);
  const [therapyTypeDropdown, settherapyTypeDropdown] = useState("Select");

  const [PriorityDropdown, setPriorityDropdown] = useState("Normal");
  const [locationProviderDropdown, setLocationProviderDropdown] = useState([]);
  const [selectedProviderLocation, setselectedProviderLocation] = useState({});
  const [selectedDocumentValue, setselectedDocumentValue] =
    useState("Claims History");
  const [documentTypeDropdownList, setdocumentTypeDropdownList] = useState([]);

  const [highlightData, setHighlightData] = useState("");

  const [isLocked, setIsLocked] = useState(true);
  const [selectedPatientValue, setselectedPatientValue] = useState({
    name: "Patient not selected",
    data: {
      general: {
        name: {
          fullName: "Patient not selected",
        },
      },
    },
  });
  const [selectedOrderValue, setselectedOrderValue] = useState({
    name: "Order not selected",
  });
  const [selectedProviderValue, setselectedProviderValue] = useState({
    name: "Provider not selected",
  });
  let processedDataObj = {
    patientKeyValues: [],
    providerKeyValues: [],
    orderKeyValues: [],
  };
  const [processedData, setProcessedData] = useState(processedDataObj);

  const [processError, setProcessError] = useState(false);

  const [message, setMessage] = useState({ msg: "", for: "" });
  const [saveMsgSucessPopup, setsaveMsgSucessPopup] = useState(false);
  const [editable, setEditable] = useState(false);
  const [actualFaxResponseData, setActualFaxResponseData] = useState({});
  const [saveButtonEnable, setSaveButtonEnable] = useState(false);
  const [resetButtonEnable, setResetButtonEnable] = useState(false);
  const [moveFaxToTrash, setMoveFaxToTrash] = useState(true);
  const [moveChildFaxToTrash, setMoveChildFaxToTrash] = useState(true);
  const [isLastChild, setIsLastChild] = useState(false);
  const [isRedirected, setIsRedirected] = useState(true);

  const [pagesArray, setPagesArray] = useState([]);
  const [pageOriginalNum, setpageOriginalNum] = useState([]);

  // Check the user if and check the getting fax is locked or not
  // If it is locked then send to the Index page.
  useEffect(() => {
    if (!cookies?.firstName) {
      window?.location?.replace(`${window?.location?.origin}`);
    }
    let faxId = "";
    if (props?.location?.state?.pdfVal) {
      faxId = props?.location?.state?.pdfVal?.Id;
    } else if (props?.location?.state?.parent) {
      faxId = props?.location?.state?.parent?.Id;
    }

    if(!isDemo){
      axiosRequest
      .get(`${process.env.REACT_APP_BaseUrl}faxlocked/${faxId}`)
      .then((res) => {
        if (res.data.email && cookies.email !== res.data.email) {
          history.push({
            pathname: `/home`,
            state: {
              indexPageState: history?.location?.state?.indexPageState
                ? history?.location?.state?.indexPageState
                : { alias: [], searchCallerId: "", pageNumber: 1 },
            },
          });
        } else {
          setIsLocked(true);
        }
      })
      .catch((err) => {
        console.log(err, "isLocked");
        history.push({ pathname: `/`, state: {} });
      });
    }
  }, []);

  const getLoadingText = (loader, patientType, providerType, orderType) => {
    if (loader === "create&attachOrderLoader") {
      // Building message for order process
      const newItems = [
        patientType === "New" ? "patient" : null,
        providerType === "New" ? "provider" : null,
        orderType === "New" ? "order" : null,
      ].filter(Boolean);

      if (newItems.length > 0) {
        return `Creating ${newItems.join(", ")}...`;
      }
      return "Attaching to order...";
    } else if (loader === "create&AttPatientLoader") {
      // Building message for patient process
      const newItems = [
        patientType === "New" ? "patient" : null,
        providerType === "New" ? "provider" : null,
      ].filter(Boolean);

      if (newItems.length > 0) {
        return `Creating ${newItems.join(", ")}...`;
      }
      return "Attaching to patient...";
    }
    return ""; // Fallback
  };

  //Get the pdf from fax id either it is parent of child.
  useEffect(() => {
    if (isLocked === true && props) {
      const fetchPdf = async () => {
        try {
          if (props?.location?.state?.pdfVal) {
            if (props?.location?.state?.pdfVal?.Id) {
              const url = `${process.env.REACT_APP_BaseUrl}viewpdf/${props?.location?.state?.pdfVal?.Id}`;
              const faxId = props?.location?.state?.pdfVal?.Id;

              try {
                const blob = await pdfCacheManager.fetchPdfWithCache(
                  url,
                  faxId,
                );
                setUploadeFiles(blob);
              } catch (err) {
                console.error("Error fetching PDF:", err);
              }
            }

            // Handle child PDF array processing
            let childPdfAry = props?.location?.state?.pdfVal?.ChildPdf;
            let childPdfAryLength =
              props?.location?.state?.pdfVal?.ChildPdf?.length;
            let childPagesAry = [];

            if (childPdfAryLength > 0) {
              for (let i = 0; i < childPdfAryLength; i++) {
                childPagesAry.push(childPdfAry[i].pages);
              }
              childPagesAry = childPagesAry.reduce((r, a) => r.concat(a), []);
              setPagesArray([...childPagesAry]);
            }
          } else if (props?.location?.state?.parent) {
            setCurrentPage("child");

            const url = `${process.env.REACT_APP_BaseUrl}viewpdf/${props?.location?.state?.parent?.Id}/${props?.location?.state?.child?.id}`;
            const parentId = props?.location?.state?.parent?.Id;
            const childId = props?.location?.state?.child?.id;

            try {
              const blob = await pdfCacheManager.fetchPdfWithCache(
                url,
                parentId,
                true,
                childId,
              );
              setUploadeFiles(blob);
            } catch (err) {
              console.error("Error fetching child PDF:", err);
            }

            // Handle child pages array
            let childPdfAryTemp = props?.location?.state?.child?.pages;
            setpageOriginalNum([...childPdfAryTemp]);
          }
        } catch (error) {
          console.error("Error in PDF fetch process:", error);
        }
      };

      fetchPdf();
    }
  }, [isLocked === true]);

  // Set the pdf to the -@react-pdf-viewer/thumbnail library.
  useEffect(() => {
    if (uploadFiles) {
      setUploadedPdf(uploadFiles);
    }
  }, [uploadFiles]);

  let patientKeys = {
    patientKeyValues: {
      FirstName: "",
      LastName: "",
      Gender: "",
      DateOfBirth: "",
      Address: {
        addressLine: "",
        city: "",
        state: "",
        zip: "",
      },
      Contact: "",
    },
    providerKeyValues: {
      ProviderFirstName: "",
      ProviderLastName: "",
      ProviderPhone: "",
      ProviderFax: "",
      ProviderNPI: "",
      Address: {
        addressLine: "",
        city: "",
        state: "",
        zip: "",
      },
    },
    orderKeyValues: {
      DateWritten: "",
      LengthOfNeed: "",
      DiagnosisCode: "",
    },
  };

  const [patientErrorMessage, setPatientErrorMessage] = useState(patientKeys);

  let summaryErrParams = {
    patientType: "",
    documentType: "",
    therapyType: "",
    orderType: "",
    providerType: "",
    priorityL: "",
    selectedPatient: "",
    selectedOrder: "",
    selectedProvider: "",
    providerLocation: "",
  };
  const [summaryParamsErrorMessage, setSummaryParamsErrorMessage] =
    useState(summaryErrParams);

  const [saveType, setSaveType] = useState("");
  const [loader, setLoader] = useState("");

  let staticPatientComponent = [
    {
      labelName: "Patient First Name",
      labelValue: "",
      labelType: "text",
      labelEditType: "text",
      labelBindValue: "FirstName",
      labelPlaceHolder: "Enter Patient First",
      labelStartColor: "red",
      labelHide: false,
    },
    {
      labelName: "Patient Last Name",
      labelValue: "",
      labelType: "text",
      labelEditType: "text",
      labelBindValue: "LastName",
      labelPlaceHolder: "Enter Patient Last Name",
      labelStartColor: "red",
      labelHide: false,
    },
    {
      labelName: "Patient Gender",
      labelValue: "",
      labelType: "text",
      labelEditType: "select",
      labelBindValue: "Gender",
      labelPlaceHolder: "Enter Patient Gender",
      labelStartColor: "red",
      labelHide: false,
    },
    {
      labelName: "Patient DOB",
      labelValue: "",
      labelType: "text",
      labelEditType: "date",
      labelBindValue: "DateOfBirth",
      labelPlaceHolder: "Enter Patient DOB",
      labelStartColor: "red",
      labelHide: false,
    },
    {
      labelName: "Patient Phone",
      labelValue: "",
      labelType: "text",
      labelEditType: "text",
      labelBindValue: "Contact",
      labelPlaceHolder: "Enter Patient Phone",
      labelStartColor: "red",
      labelHide: false,
    },
    {
      labelName: "Patient Address",
      labelValue: {
        addressLine: "",
        city: "",
        state: "",
        zip: "",
      },
      labelAddressName: {
        city: "Patient City",
        state: "Patient State",
        zip: "Patient Zip",
      },
      labelType: "address",
      labelEditType: "address",
      labelBindValue: "Address",
      labelPlaceHolder: "Enter Patient Address",
      labelStartColor: "red",
      labelHide: false,
    },
  ];

  let staticProviderComponent = [
    {
      labelName: "Provider First Name",
      labelValue: "",
      labelType: "text",
      labelEditType: "text",
      labelBindValue: "ProviderFirstName",
      labelPlaceHolder: "Enter Provider First Name",
      labelStartColor: "blue",
      labelHide: false,
    },
    {
      labelName: "Provider Last Name",
      labelValue: "",
      labelType: "text",
      labelEditType: "text",
      labelBindValue: "ProviderLastName",
      labelPlaceHolder: "Enter Provider Last Name",
      labelStartColor: "blue",
      labelHide: false,
    },
    {
      labelName: "Provider Phone",
      labelValue: "",
      labelType: "text",
      labelEditType: "text",
      labelBindValue: "ProviderPhone",
      labelPlaceHolder: "Enter Provider Phone",
      labelStartColor: "blue",
      labelHide: false,
    },
    {
      labelName: "Provider Fax",
      labelValue: "",
      labelType: "text",
      labelEditType: "text",
      labelBindValue: "ProviderFax",
      labelPlaceHolder: "Enter Provider Fax",
      labelStartColor: "blue",
      labelHide: false,
    },
    {
      labelName: "Provider NPI",
      labelValue: "",
      labelType: "text",
      labelEditType: "text",
      labelBindValue: "ProviderNPI",
      labelPlaceHolder: "Enter Provider NPI",
      labelStartColor: "blue",
      labelHide: false,
    },
    {
      labelName: "Provider Address",
      labelValue: {
        addressLine: "",
        city: "",
        state: "",
        zip: "",
      },
      labelAddressName: {
        city: "Provider City",
        state: "Provider State",
        zip: "Provider Zip",
      },
      labelType: "address",
      labelEditType: "address",
      labelBindValue: "Address",
      labelPlaceHolder: "Enter Provider Address",
      labelStartColor: "blue",
      labelHide: false,
    },
  ];

  let staticOrderComponent = [
    {
      labelName: "Date Written",
      labelValue: "",
      labelType: "text",
      labelEditType: "date",
      labelBindValue: "DateWritten",
      labelPlaceHolder: "Enter Date Written",
      labelStartColor: "",
      labelHide: false,
    },
    {
      labelName: "Length of Need",
      labelValue: "",
      labelType: "text",
      labelEditType: "text",
      labelBindValue: "LengthOfNeed",
      labelPlaceHolder: "Enter Length of Need",
      labelStartColor: "",
      labelHide: false,
    },
    {
      labelName: "Diagnosis Code",
      labelValue: "",
      labelType: "text",
      labelEditType: "text",
      labelBindValue: "DiagnosisCode",
      labelPlaceHolder: "Enter Diagnosis Code",
      labelStartColor: "",
      labelHide: false,
    },
  ];
  const [cookies] = useCookies();

  // If the user Cookies not set the the goes to the login page.
  if (!cookies?.firstName) {
    window?.location?.replace(`${window?.location?.origin}`);
  }

  // Closed the popup.
  const closePopup = () => {
    setaddBtnPopup(false);
    setattachPatientPopup(false);
    setattachOrderPopup(false);
    setcreateAttachPatientPopup(false);
    setcreateAttachOrderPopup(false);
  };
  const currentyr = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const currentDay = new Date().getDate();
  let currentdtemp = new Date();
  const year = currentdtemp.getFullYear();
  const month = String(currentdtemp.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(currentdtemp.getDate()).padStart(2, "0"); // Get day and pad with 0 if necessary
  const currentdt = `${year}-${month}-${day}`;
  const [cursorSelectetion, setCursorSelectetion] = useState(0);
  const [cursorSelectetionPhone, setCursorSelectetionPhone] = useState(0);
  const [cursorSelectetionFax, setCursorSelectetionFax] = useState(0);

  function formatDate(date, val) {
    let month = date.getMonth() + 1;
    month = month % 12;
    month = month ? "0" + month : "12";
    let date1 = date.getDate();
    date1 = "0" + date1;
    return month?.slice(-2) + "/" + date1.slice(-2) + "/" + date.getFullYear();
  }
  // This is saving formate for date.
  function saveDateFormat(date) {
    let month = date.getMonth() + 1;
    month = month % 12;
    month = month ? "0" + month : "12";
    let date1 = date.getDate();
    date1 = "0" + date1;
    return date.getFullYear() + "-" + month?.slice(-2) + "-" + date1.slice(-2);
  }

  // In this useEffect we check the faxid having any one is locked if there then,
  // it moves home page else check the user is same then it will continue.
  useEffect(() => {
    let faxId = "";
    if (props?.location?.state?.pdfVal) {
      faxId = props?.location?.state?.pdfVal?.Id;
    } else if (props?.location?.state?.parent) {
      faxId = props?.location?.state?.parent?.Id;
    }

    if(!isDemo){
      axiosRequest
      .get(`${process.env.REACT_APP_BaseUrl}faxlocked/${faxId}`)
      .then((res) => {
        if (res.data.email && cookies.email !== res.data.email) {
          history.push({
            pathname: `/home`,
            state: {
              indexPageState: history?.location?.state?.indexPageState
                ? history?.location?.state?.indexPageState
                : { alias: [], searchCallerId: "", pageNumber: 1 },
            },
          });
        } else {
          setIsLocked(true);
        }
      })
      .catch((err) => {
        console.log(err, "isLocked");
        history.push({ pathname: `/`, state: {} });
      });
    }
  }, []);

  // If the fax is not locked then get the pdf and get calls for initial load.
  useEffect(() => {
    if (isLocked == true && props) {
      let url = "";
      let faxId = "";
      let isChild = false;
      let childId = null;

      if (props?.location?.state?.pdfVal?.Id) {
        faxId = props?.location?.state?.pdfVal?.Id;
        url = `${process.env.REACT_APP_BaseUrl}viewpdf/${faxId}`;
        getProcessFax(faxId, "", false);
      } else {
        faxId = props?.location?.state?.parent?.Id;
        childId = props?.location?.state?.child?.id;
        isChild = true;
        url = `${process.env.REACT_APP_BaseUrl}viewpdf/${faxId}/${childId}`;
        getProcessFax(faxId, childId, false);
        setCurrentPage("child");

        let totalPages = parseInt(props?.location?.state?.parent.Pages);
        let totalPagesArray = Array.from(
          Array(totalPages),
          (_, index) => index + 1,
        );
        let childpages = props?.location?.state?.parent.ChildPdf;
        let childPagesArray = [];
        childpages?.forEach((el) => {
          if (
            el.pages?.length > 1 &&
            (el?.deleted == true || el.id == props?.location?.state?.child?.id)
          ) {
            el.pages.forEach((p) => {
              childPagesArray.push(p);
            });
          } else if (
            el.pages?.length == 1 &&
            (el?.deleted == true || el.id == props?.location?.state?.child?.id)
          ) {
            childPagesArray.push(el.pages[0]);
          }
        });
        if (childPagesArray?.length == totalPagesArray?.length) {
          setIsLastChild(true);
        }
      }

      // Use the PDF cache manager
      pdfCacheManager
        .fetchPdfWithCache(url, faxId, isChild, childId)
        .then((blob) => {
          setUploadeFiles(blob);
        })
        .catch((err) => {
          console.log(err, "viewpdf");
        });

      getTherapyTypeList();
      getDocumentTypeList();
      if (
        props?.location?.state?.pdfVal?.Status == "Processing" ||
        props?.location?.state?.parent?.Status == "Processing"
      ) {
        setResetButtonEnable(true);
      }
    }
  }, [isLocked == true]);

  //This is the function for getting the values from OCR and saved from database
  // and it formated and set to the associated object.

  const getProcessFax = (parent, child, reset) => {
    console.log("GETTING PROCESSED FAX");
    setLoader("processFaxLoader");

    // Construct the URL
    let url = "";
    if (child === "") {
      if (reset === true) {
        url = `${process.env.REACT_APP_BaseUrl}resetfax/${parent}`;
      } else {
        url = `${process.env.REACT_APP_BaseUrl}processfax/${parent}`;
      }
    } else {
      if (reset === true) {
        url = `${process.env.REACT_APP_BaseUrl}resetfax/${parent}/${child}`;
      } else {
        url = `${process.env.REACT_APP_BaseUrl}processfax/${parent}/${child}`;
      }
    }

    const faxId = child === "" ? parent : `${parent}_${child}`;

    faxCacheManager
      .fetchProcessedFax(url, faxId)
      .then((actualArrayRes) => {
        console.log("response data: ", actualArrayRes);
        setActualFaxResponseData(actualArrayRes);

        // Process the data
        let ProcessFaxData = {};
        let providerData = {};
        let orderData = {};

        let contacts =
          actualArrayRes?.patientMaster?.contacts?.contacts?.length > 0
            ? actualArrayRes?.patientMaster?.contacts?.contacts
            : "";

        let contactIndex =
          contacts?.length > 0
            ? contacts?.findIndex(
                (el) => el?.type === "Cell" || el?.type === "Home",
              )
            : -1;

        ProcessFaxData = {
          FirstName: `${
            actualArrayRes?.patientMaster?.general?.name?.firstName || ""
          }`,
          LastName: `${
            actualArrayRes?.patientMaster?.general?.name?.lastName || ""
          }`,
          DateOfBirth: `${
            actualArrayRes?.patientMaster?.general?.dateOfBirth || ""
          }`,
          Gender: `${actualArrayRes?.patientMaster?.general?.gender || ""}`,
          Contact: `${
            contacts &&
            contactIndex !== -1 &&
            contacts[contactIndex]?.value !== null
              ? contacts[contactIndex]?.value
              : ""
          }`,
          Address: actualArrayRes?.patientMaster?.addresses?.patient || {
            addressLine: "",
            city: "",
            state: "",
            zip: "",
          },
        };

        providerData = {
          ProviderFirstName: `${
            actualArrayRes?.referringProvider?.general?.name?.firstName || ""
          }`,
          ProviderLastName: `${
            actualArrayRes?.referringProvider?.general?.name?.lastName || ""
          }`,
          ProviderPhone: `${
            actualArrayRes?.referringProvider?.primaryLocation?.contacts
              ?.phone || ""
          }`,
          ProviderFax: `${
            actualArrayRes?.referringProvider?.primaryLocation?.contacts?.fax ||
            ""
          }`,
          ProviderNPI: `${
            actualArrayRes?.referringProvider?.general?.npi || ""
          }`,
          Address: {
            addressLine:
              actualArrayRes?.referringProvider?.primaryLocation?.address
                ?.addressLine || "",
            city:
              actualArrayRes?.referringProvider?.primaryLocation?.address
                ?.city || "",
            state:
              actualArrayRes?.referringProvider?.primaryLocation?.address
                ?.state || "",
            zip:
              actualArrayRes?.referringProvider?.primaryLocation?.address
                ?.zip || "",
          },
        };

        orderData = {
          DateWritten: `${
            actualArrayRes?.order?.prescription?.effectiveDate || currentdt
          }`,
          LengthOfNeed: `${
            actualArrayRes?.order?.prescription?.products[0]?.primitive
              ?.lengthOfNeed || 1
          }`,
          DiagnosisCode: `${
            actualArrayRes?.order?.prescription?.products[0]?.primitive
              ?.diagnosisCodes[0] || ""
          }`,
        };

        // Set dropdown values
        setpatientTypeDropdown(`${actualArrayRes?.patient_type || ""}`);
        setorderTypeDropdown(`${actualArrayRes?.order_type || ""}`);
        setproviderTypeDropdown(`${actualArrayRes?.provider_type || ""}`);

        // Set selected values
        if (actualArrayRes?.patientMaster?.id) {
          setselectedPatientValue({
            name: `${
              actualArrayRes?.patientMaster?.general?.name?.fullName || ""
            } ${
              actualArrayRes?.patientMaster?.general?.dateOfBirth
                ? "(" +
                  formatDate(
                    new Date(
                      actualArrayRes?.patientMaster?.general?.dateOfBirth?.includes(
                        "T",
                      )
                        ? actualArrayRes?.patientMaster?.general?.dateOfBirth
                        : actualArrayRes?.patientMaster?.general?.dateOfBirth?.replaceAll(
                            "-",
                            "/",
                          ),
                    ),
                  ) +
                  ")"
                : ""
            }`,
            data: actualArrayRes?.patientMaster || {},
          });
        }

        if (actualArrayRes?.order?.id) {
          setselectedOrderValue({
            name: actualArrayRes?.order?.displayId || "",
            data: actualArrayRes?.order || {},
          });
        }

        if (actualArrayRes?.referringProvider?.id) {
          setselectedProviderValue({
            name: `${
              actualArrayRes?.referringProvider?.general?.name?.firstName || ""
            } ${
              actualArrayRes?.referringProvider?.general?.name?.lastName || ""
            } ${
              actualArrayRes?.referringProvider?.general?.npi
                ? "(" + actualArrayRes?.referringProvider?.general?.npi + ")"
                : ""
            }`,
            data: actualArrayRes?.referringProvider || {},
          });

          if (actualArrayRes?.referringProvider?.primaryLocation) {
            setselectedProviderLocation({
              name: `${actualArrayRes?.referringProvider?.primaryLocation?.address?.addressLine}, ${actualArrayRes?.referringProvider?.primaryLocation?.address?.city}, ${actualArrayRes?.referringProvider?.primaryLocation?.address?.state}, ${actualArrayRes?.referringProvider?.primaryLocation?.address?.zip}`,
              data: actualArrayRes?.referringProvider?.primaryLocation || {},
            });
          }
        }

        setselectedDocumentValue(`${actualArrayRes?.document_type || ""}`);
        settherapyTypeDropdown(`${actualArrayRes?.product_type || ""}`);
        setPriorityDropdown(
          `${
            actualArrayRes?.order?.priorityLevel === "SameDay"
              ? "Urgent"
              : actualArrayRes?.order?.priorityLevel || ""
          }`,
        );

        // Process static components
        let keysare = Object.keys(ProcessFaxData);
        staticPatientComponent?.forEach((element) => {
          if (keysare?.indexOf(element.labelBindValue) !== -1) {
            let addressTemp = {
              addressLine: "",
              city: "",
              state: "",
              zip: "",
            };
            if (element.labelBindValue === "Address") {
              addressTemp.addressLine =
                ProcessFaxData[element.labelBindValue]?.addressLine ?? "";
              addressTemp.city =
                ProcessFaxData[element.labelBindValue]?.city ?? "";
              addressTemp.state =
                ProcessFaxData[element.labelBindValue]?.state ?? "";
              addressTemp.zip =
                ProcessFaxData[element.labelBindValue]?.zip ?? "";
              element.labelValue = addressTemp;
            } else if (element.labelBindValue === "DateOfBirth") {
              element.labelValue = ProcessFaxData[element?.labelBindValue]
                ? formatDate(
                    new Date(
                      ProcessFaxData[element?.labelBindValue]?.includes("T")
                        ? ProcessFaxData[element?.labelBindValue]
                        : ProcessFaxData[element?.labelBindValue]?.replaceAll(
                            "-",
                            "/",
                          ),
                    ),
                  )
                : "";
            } else if (element.labelBindValue === "Contact") {
              element.labelValue = ProcessFaxData[element?.labelBindValue]
                ? formatPhoneNumber(ProcessFaxData[element?.labelBindValue])
                : "";
            } else {
              element.labelValue = ProcessFaxData[element.labelBindValue];
            }
            if (actualArrayRes?.patient_type === "Existing") {
              element.labelGreyout = true;
            }
          }
        });

        // Process provider components
        let keysareProvider = Object.keys(providerData);
        staticProviderComponent?.forEach((element) => {
          if (keysareProvider?.indexOf(element.labelBindValue) !== -1) {
            element.labelValue = providerData[element.labelBindValue];
            if (actualArrayRes?.provider_type === "Existing") {
              element.labelGreyout = true;
            }
            if (actualArrayRes?.order_type === "Existing") {
              element.labelHide = true;
            }
            if (
              element.labelBindValue === "ProviderPhone" ||
              element.labelBindValue === "ProviderFax"
            ) {
              element.labelValue = providerData[element?.labelBindValue]
                ? formatPhoneNumber(providerData[element?.labelBindValue])
                : "";
            }
          }
        });

        // Process order components
        let keysareOrder = Object.keys(orderData);
        staticOrderComponent?.forEach((element) => {
          if (keysareOrder?.indexOf(element.labelBindValue) !== -1) {
            element.labelValue = orderData[element.labelBindValue];
            if (actualArrayRes?.order_type === "Existing") {
              element.labelGreyout = true;
              element.labelHide = false;
            }
          }
        });

        // Set processed data
        let processedDataObj = {
          patientKeyValues: [...staticPatientComponent],
          providerKeyValues: [...staticProviderComponent],
          orderKeyValues: [...staticOrderComponent],
        };
        setProcessedData(processedDataObj);

        // Handle coordinates if present
        if ("coordinatesJson" in actualArrayRes) {
          try {
            const JSONParsedCoordinates = JSON.parse(
              actualArrayRes["coordinatesJson"],
            );
            setHighlightData((prevState) => ({
              ...prevState,
              coordinates: JSONParsedCoordinates,
            }));
            console.log("Set coordinates", JSONParsedCoordinates);
          } catch (error) {
            console.error("Failed to parse coordinates JSON:", error);
          }
        }

        setLoader("");
        if (reset === true) {
          setSaveType("reset");
          setResetButtonEnable(false);
        }
      })
      .catch((err) => {
        console.log(err, "processfax");
        if (err?.response?.data?.length < 2) {
          setMessage({ msg: err?.response?.data[0]?.Message, for: "error" });
        } else {
          setMessage({ msg: err.message || err?.response?.data, for: "error" });
        }
        setProcessError(true);
        setLoader("");
      });
  };
  // This is function for getting the list of Therapy type.
  const getTherapyTypeList = () => {
    axiosRequest
      .get(`${process.env.REACT_APP_BaseUrl}therapytypelist`)
      .then((res) => {
        let actualTherapyArray = res.data;
        let therapyArray = [];
        let len = actualTherapyArray?.content?.length;

        for (let i = 0; i < len; i++) {
          therapyArray.push({
            Id: `${
              actualTherapyArray?.content[i]?.product_type_id
                ? actualTherapyArray?.content[i]?.product_type_id
                : ""
            }`,
            Type: `${
              actualTherapyArray?.content[i]?.product_type_name
                ? actualTherapyArray?.content[i]?.product_type_name
                : ""
            }`,
          });
        }
        therapyArray = sortArrayListAsc(therapyArray, "Type");
        settherapyTypeDropdownList([...therapyArray]);
      })
      .catch((err) => {
        console.log(err, "therapytypelist");
      });
  };

  // This is function for getting the list of Document type.
  const getDocumentTypeList = () => {
    axiosRequest
      .get(`${process.env.REACT_APP_BaseUrl}documenttypelist`)
      .then((res) => {
        let actualDocumentArray = res.data;
        let documentArray = [];
        let len = actualDocumentArray?.content?.length;

        for (let i = 0; i < len; i++) {
          documentArray.push({
            documentType: `${
              actualDocumentArray?.content[i]?.document
                ? actualDocumentArray?.content[i]?.document
                : ""
            }`,
          });
        }
        documentArray = sortArrayListAsc(documentArray, "documentType");
        setdocumentTypeDropdownList([...documentArray]);
      })
      .catch((err) => {
        console.log(err, "documenttypelist");
      });
  };

  // Set the pdf to the -@react-pdf-viewer library.
  useEffect(() => {
    if (uploadFiles) {
      setUploadedPdf(uploadFiles);
    }
  }, [uploadFiles]);

  // Drop down auto close event bind and unbind.
  useEffect(() => {
    function handleClickOutside(event) {
      if (outSideRef.current && !outSideRef.current.contains(event.target)) {
        if (patientDetailpopup) {
          setPatientDetailpopup(false);
        }
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("click", handleClickOutside);
    };
  }, [outSideRef, patientDetailpopup]);

  // These are some constant regex.
  const lengthOfNeedRegex = /^(0?[1-9]|[1-9][0-9])$/;
  const nameRegex = new RegExp("[A-Za-zs]", "g");
  const nameSpacereg = new RegExp("[A-Za-z- s]", "g");
  const numRegex = /^[0-9\b]+$/;
  const cityRegex = /^[A-Za-z\s]*$/;

  const dateValidation = (date) => {
    if (date) {
      let year = date?.split("-")[0];
      let month = date?.split("-")[1];
      let day = date?.split("-")[2];
      if (!(year <= currentyr)) {
        return currentdt;
      } else if (!(month <= currentMonth) && year == currentyr) {
        return currentdt;
      } else if (
        !(day <= currentDay) &&
        month == currentMonth &&
        year == currentyr
      ) {
        return currentdt;
      } else if (year?.length > 4) {
        year = year?.slice(0, 4);
        let datePass = `${year}-${date?.split("-")[1]}-${date?.split("-")[2]}`;
        return datePass;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  // This is on change method will add the value on when event is triggered.
  const editeValue = (e, key) => {
    let keyDataTemp = JSON.parse(JSON.stringify(processedData[key]));
    keyDataTemp = keyDataTemp?.map((object) => {
      if (object.labelBindValue == e.target.name) {
        if (
          e.target.name == "FirstName" ||
          e.target.name == "LastName" ||
          e.target.name == "ProviderFirstName" ||
          e.target.name == "ProviderLastName"
        ) {
          if (nameSpacereg?.test(e.nativeEvent.data)) {
            return { ...object, labelValue: e.target.value };
          } else {
            return {
              ...object,
              labelValue: e.target.value?.slice(0, e.target.value?.length - 1),
            };
          }
        } else if (
          e.target.name == "Contact" ||
          e.target.name == "ProviderPhone" ||
          e.target.name == "ProviderFax"
        ) {
          // cursor issue for Providerphone,Providerfax,Patietnphone
          const cursorIssue = (
            length,
            objectLength,
            selectionStart,
            selectionEnd,
            setCursorState,
          ) => {
            if (length <= objectLength && length < 15) {
              setCursorState(selectionStart);
            } else if (length >= objectLength && length < 15) {
              if (selectionEnd == 4) {
                if (length < 5) {
                  setCursorState(selectionEnd + 3);
                } else {
                  setCursorState(selectionEnd + 2);
                }
              } else if (selectionEnd == 5) {
                setCursorState(selectionEnd + 2);
              } else if (selectionEnd == 6) {
                setCursorState(selectionEnd + 1);
              } else if (selectionEnd == 10) {
                setCursorState(selectionEnd + 1);
              } else {
                setCursorState(selectionEnd);
              }
            } else if (length >= 15) {
              if (selectionEnd == 5) {
                setCursorState(selectionEnd + 2);
              } else if (selectionEnd == 6) {
                setCursorState(selectionEnd + 1);
              } else if (selectionEnd == 10) {
                setCursorState(selectionEnd + 1);
              } else {
                setCursorState(selectionEnd);
              }
            }
          };
          if (e.target.name == "ProviderPhone") {
            cursorIssue(
              e.target.value?.length,
              object.labelValue?.length,
              e.target.selectionStart,
              e.target.selectionEnd,
              setCursorSelectetionPhone,
            );
          } else if (e.target.name == "ProviderFax") {
            cursorIssue(
              e.target.value?.length,
              object.labelValue?.length,
              e.target.selectionStart,
              e.target.selectionEnd,
              setCursorSelectetionFax,
            );
          } else {
            cursorIssue(
              e.target.value?.length,
              object.labelValue?.length,
              e.target.selectionStart,
              e.target.selectionEnd,
              setCursorSelectetion,
            );
          }
          if (numRegex?.test(e.nativeEvent.data)) {
            return {
              ...object,
              labelValue: formatPhoneNumber(e.target.value?.slice(0, 14)),
            };
          } else if (
            e.target.value &&
            numRegex?.test(e.target.value?.replace(/[- )(]/g, ""))
          ) {
            return { ...object, labelValue: formatPhoneNumber(e.target.value) };
          } else if (
            e.target.value &&
            !numRegex?.test(e.target.value?.replace(/[- )(]/g, ""))
          ) {
            return { ...object };
          }
        } else if (
          e.target.name == "DateOfBirth" ||
          e.target.name == "DateWritten"
        ) {
          let inputVal = e.target.value;
          if (inputVal) {
            return { ...object, labelValue: inputVal };
          }
          // else{
          //   return {...object}
          // }
        } else if (e.target.name == "LengthOfNeed") {
          if (lengthOfNeedRegex?.test(e.target.value)) {
            object.labelValue = e.target.value;
            return { ...object, labelValue: e.target.value };
          } else if (e.nativeEvent.data == null) {
            return { ...object, labelValue: "" };
          } else {
            return { ...object };
          }
        } else if (e.target.name == "ProviderNPI") {
          if (e.target.value && numRegex?.test(e.target.value)) {
            return { ...object, labelValue: e.target.value?.slice(0, 10) };
          } else if (e.target.value && !numRegex?.test(e.target.value)) {
            return { ...object };
          }
        }
        return { ...object, labelValue: e.target.value };
      } else if (
        object.labelBindValue == "Address" &&
        (e.target.name == "addressLine" ||
          e.target.name == "city" ||
          e.target.name == "state" ||
          e.target.name == "zip")
      ) {
        if (e.target.name == "zip" && !(e.target.value?.length <= 5)) {
          object.labelValue[e.target.name] = e.target.value?.slice(0, 5);
        } else if (
          e.target.name == "zip" &&
          e.target.value?.length > 0 &&
          !numRegex?.test(e.target.value)
        ) {
          object.labelValue[e.target.name] = object.labelValue[e.target.name];
        } else {
          if (e.target.name == "city") {
            if (cityRegex?.test(e.nativeEvent.data)) {
              object.labelValue[e.target.name] = e.target.value;
            }
          } else if (e.target.name == "state") {
            if (nameRegex?.test(e.nativeEvent.data)) {
              object.labelValue[e.target.name] = e.target.value.toUpperCase();
            }
          } else {
            object.labelValue[e.target.name] = e.target.value;
          }
        }
        return { ...object };
      }
      return object;
    });
    let processDataTemp = JSON.parse(JSON.stringify(processedData));
    processDataTemp[key] = keyDataTemp;
    setProcessedData(processDataTemp);
    let ErrorMessage = patientErrorMessage;
    if (
      e.target.name == "addressLine" ||
      e.target.name == "zip" ||
      e.target.name == "city" ||
      e.target.name == "state"
    ) {
      ErrorMessage[key]["Address"][e.target.name] = "";
    } else if (
      e.target.name == "ProviderPhone" ||
      e.target.name == "ProviderFax"
    ) {
      ErrorMessage[key]["ProviderPhone"] = "";
      ErrorMessage[key]["ProviderFax"] = "";
    } else {
      ErrorMessage[key][e.target.name] = "";
    }
    setPatientErrorMessage({ ...ErrorMessage });
  };

  //This is the format for phone number for usa people.
  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6,
    )}-${phoneNumber.slice(6, 10)}`;
  }

  // This is the toggle method for edit penciel icon.
  const editButtonClick = () => {
    setEditable(!editable);
    setSaveButtonEnable(!saveButtonEnable);
  };

  // This is the common method for setting up parameter for api.(create patient,create order and ...)
  const setParams = (type) => {
    let paramsNeed = {};
    let parent = "";
    let child = "";
    let moveFaxToTrashLocal = moveFaxToTrash;
    let moveChildFaxToTrashLocal = moveChildFaxToTrash;
    if (currentPage == "parent") {
      parent = props?.location?.state?.pdfVal?.Id;
      moveChildFaxToTrashLocal = false;
    } else {
      parent = props?.location?.state?.parent?.Id;
      child = props?.location?.state?.child?.id;
      if (isLastChild && moveChildFaxToTrashLocal) {
        moveFaxToTrashLocal = true;
      } else {
        moveFaxToTrashLocal = false;
      }
    }
    paramsNeed = {
      id: actualFaxResponseData?.id ? actualFaxResponseData?.id : null,
      faxId: parent,
      process_id: actualFaxResponseData?.process_id
        ? actualFaxResponseData?.process_id
        : null,
      childFaxId: child,
      patient_type: patientTypeDropdown,
      order_type: orderTypeDropdown,
      provider_type: providerTypeDropdown,
      document_type: selectedDocumentValue,
      product_type: therapyTypeDropdown,
      moveFaxToTrash: moveFaxToTrashLocal,
      moveChildFaxToTrash: moveChildFaxToTrashLocal,
      patientMaster: {
        locationId: actualFaxResponseData?.patientMaster?.locationId
          ? actualFaxResponseData?.patientMaster?.locationId
          : null,
        facilityLocationId: actualFaxResponseData?.patientMaster
          ?.facilityLocationId
          ? actualFaxResponseData?.patientMaster?.facilityLocationId
          : null,
        //patient_id this is for internal AspenLake param
        patient_id: selectedPatientValue?.data?.id
          ? selectedPatientValue?.data?.id
          : null,
        id: selectedPatientValue?.data?.id
          ? selectedPatientValue?.data?.id
          : null,
        tags: actualFaxResponseData?.patientMaster?.tags
          ? actualFaxResponseData?.patientMaster?.tags
          : null,
        general: {
          name: {
            fullName: actualFaxResponseData?.patientMaster?.general?.name
              ?.fullName
              ? actualFaxResponseData?.patientMaster?.general?.name?.fullName
              : "",
            lastName: processedData.patientKeyValues[1].labelValue,
            firstName: processedData.patientKeyValues[0].labelValue,
            middleName: "",
            // middleName: actualFaxResponseData?.patientMaster?.general?.name?.middleName ? actualFaxResponseData?.patientMaster?.general?.name?.middleName:""
          },
          prefix: actualFaxResponseData?.patientMaster?.general?.prefix
            ? actualFaxResponseData?.patientMaster?.general?.prefix
            : null,
          dateOfBirth: processedData?.patientKeyValues[3]?.labelValue
            ? saveDateFormat(
                new Date(
                  processedData?.patientKeyValues[3]?.labelValue?.includes("T")
                    ? processedData?.patientKeyValues[3]?.labelValue
                    : processedData?.patientKeyValues[3]?.labelValue?.replaceAll(
                        "-",
                        "/",
                      ),
                ),
              )
            : processedData?.patientKeyValues[3]?.labelValue,
          gender: processedData?.patientKeyValues[2]?.labelValue,
          ssn: actualFaxResponseData?.patientMaster?.general?.ssn
            ? actualFaxResponseData?.patientMaster?.general?.ssn
            : null,
          height: actualFaxResponseData?.patientMaster?.general?.height
            ? actualFaxResponseData?.patientMaster?.general?.height
            : null,
          maritalStatus: actualFaxResponseData?.patientMaster?.general
            ?.maritalStatus
            ? actualFaxResponseData?.patientMaster?.general?.maritalStatus
            : null,
          weight: actualFaxResponseData?.patientMaster?.general?.weight
            ? actualFaxResponseData?.patientMaster?.general?.weight
            : null,
          nickName: actualFaxResponseData?.patientMaster?.general?.nickName
            ? actualFaxResponseData?.patientMaster?.general?.nickName
            : null,
        },
        contacts: {
          contacts: [
            {
              value: processedData.patientKeyValues[4]?.labelValue
                ? String(processedData.patientKeyValues[4].labelValue).replace(
                    /[- )(]/g,
                    "",
                  )
                : "",
              type: actualFaxResponseData?.patientMaster?.contacts?.contacts
                ?.type
                ? actualFaxResponseData?.patientMaster?.contacts?.contacts?.type
                : "Home",
              ext: actualFaxResponseData?.patientMaster?.contacts?.contacts?.ext
                ? actualFaxResponseData?.patientMaster?.contacts?.contacts?.ext
                : null,
            },
          ],
          preferredContactType: actualFaxResponseData?.patientMaster?.contacts
            ?.preferredContactType
            ? actualFaxResponseData?.patientMaster?.contacts
                ?.preferredContactType
            : null,
          preferredCallTime: actualFaxResponseData?.patientMaster?.contacts
            ?.preferredCallTime
            ? actualFaxResponseData?.patientMaster?.contacts?.preferredCallTime
            : null,
        },
        displayId: selectedPatientValue?.data?.displayId
          ? selectedPatientValue?.data?.displayId
          : "",
        addresses: {
          patient: {
            state:
              processedData?.patientKeyValues[5]?.labelValue?.state?.toUpperCase(),
            addressLine:
              processedData?.patientKeyValues[5]?.labelValue?.addressLine,
            city: processedData?.patientKeyValues[5]?.labelValue?.city,
            zip: processedData?.patientKeyValues[5]?.labelValue?.zip,
            addressLine2: actualFaxResponseData?.patientMaster?.addresses
              ?.patient?.addressLine2
              ? actualFaxResponseData?.patientMaster?.addresses?.patient
                  ?.addressLine2
              : null,
          },
          skipDeliveryAddressVerification: actualFaxResponseData?.patientMaster
            ?.addresses?.skipDeliveryAddressVerification
            ? actualFaxResponseData?.patientMaster?.addresses
                ?.skipDeliveryAddressVerification
            : false,
          skipPatientAddressVerification: actualFaxResponseData?.patientMaster
            ?.addresses?.skipPatientAddressVerification
            ? actualFaxResponseData?.patientMaster?.addresses
                ?.skipPatientAddressVerification
            : false,
          delivery: actualFaxResponseData?.patientMaster?.addresses?.delivery
            ? actualFaxResponseData?.patientMaster?.addresses?.delivery
            : null,
        },
        signatureOnFile: actualFaxResponseData?.patientMaster?.signatureOnFile
          ? actualFaxResponseData?.patientMaster?.signatureOnFile
          : null,
        employerContact: actualFaxResponseData?.patientMaster?.employerContact
          ? actualFaxResponseData?.patientMaster?.employerContact
          : null,
        taxExemption: actualFaxResponseData?.patientMaster?.taxExemption
          ? actualFaxResponseData?.patientMaster?.taxExemption
          : null,
        status: actualFaxResponseData?.patientMaster?.status
          ? actualFaxResponseData?.patientMaster?.status
          : null,
        medicalReleaseInfo: actualFaxResponseData?.patientMaster
          ?.medicalReleaseInfo
          ? actualFaxResponseData?.patientMaster?.medicalReleaseInfo
          : null,
        emergencyContact: actualFaxResponseData?.patientMaster?.emergencyContact
          ? actualFaxResponseData?.patientMaster?.emergencyContact
          : null,
        eesponsibleContact: actualFaxResponseData?.patientMaster
          ?.eesponsibleContact
          ? actualFaxResponseData?.patientMaster?.eesponsibleContact
          : null,
      },
      order: {
        id: selectedOrderValue?.data?.id ? selectedOrderValue?.data?.id : "",
        type: selectedOrderValue?.data?.type
          ? selectedOrderValue?.data?.type
          : "",
        patient: selectedOrderValue?.data?.patient
          ? selectedOrderValue?.data?.patient
          : null,
        displayId: selectedOrderValue?.data?.displayId
          ? selectedOrderValue?.data?.displayId
          : "",
        archived: selectedOrderValue?.data?.archived
          ? selectedOrderValue?.data?.archived
          : false,
        audit: {
          createdBy: {
            fullName: selectedOrderValue?.data?.audit?.createdBy?.fullName
              ? selectedOrderValue?.data?.audit?.createdBy?.fullName
              : null,
            lastName: selectedOrderValue?.data?.audit?.createdBy?.lastName
              ? selectedOrderValue?.data?.audit?.createdBy?.lastName
              : "",
            firstName: selectedOrderValue?.data?.audit?.createdBy?.firstName
              ? selectedOrderValue?.data?.audit?.createdBy?.firstName
              : "",
            middleName: selectedOrderValue?.data?.audit?.createdBy?.middleName
              ? selectedOrderValue?.data?.audit?.createdBy?.middleName
              : "",
          },
          modifiedOn: selectedOrderValue?.data?.audit?.modifiedOn
            ? selectedOrderValue?.data?.audit?.modifiedOn
            : "",
          createdOn: selectedOrderValue?.data?.audit?.createdOn
            ? selectedOrderValue?.data?.audit?.createdOn
            : "",
          modifiedBy: {
            fullName: selectedOrderValue?.data?.audit?.modifiedBy?.fullName
              ? selectedOrderValue?.data?.audit?.modifiedBy?.fullName
              : null,
            lastName: selectedOrderValue?.data?.audit?.modifiedBy?.lastName
              ? selectedOrderValue?.data?.audit?.modifiedBy?.lastName
              : null,
            firstName: selectedOrderValue?.data?.audit?.modifiedBy?.firstName
              ? selectedOrderValue?.data?.audit?.modifiedBy?.firstName
              : null,
            middleName: selectedOrderValue?.data?.audit?.modifiedBy?.middleName
              ? selectedOrderValue?.data?.audit?.modifiedBy?.middleName
              : null,
          },
        },
        startDate: selectedOrderValue?.data?.startDate
          ? selectedOrderValue?.data?.startDate
          : "",
        priorityLevel: PriorityDropdown
          ? PriorityDropdown == "Urgent"
            ? "SameDay"
            : PriorityDropdown
          : null,
        serviceLocation: {
          name: selectedOrderValue?.data?.serviceLocation?.name
            ? selectedOrderValue?.data?.serviceLocation?.name
            : null,
          id: selectedOrderValue?.data?.serviceLocation?.id
            ? selectedOrderValue?.data?.serviceLocation?.id
            : null,
          npi: selectedOrderValue?.data?.serviceLocation?.npi
            ? selectedOrderValue?.data?.serviceLocation?.npi
            : null,
        },
        delivery: selectedOrderValue?.data?.delivery
          ? selectedOrderValue?.data?.delivery
          : null,
        status: selectedOrderValue?.data?.status
          ? selectedOrderValue?.data?.status
          : "",
        referringProviderId: selectedProviderValue?.data?.id
          ? selectedProviderValue?.data?.id
          : null,
        referringProviderLocationId: selectedProviderLocation?.data?.id
          ? selectedProviderLocation?.data?.id
          : null,
        general: selectedProviderValue?.data?.general
          ? selectedProviderValue?.data?.general
          : null,
        prescription: {
          effectiveDate: processedData.orderKeyValues[0].labelValue
            ? processedData.orderKeyValues[0].labelValue
            : "",
          treatingProviderId: selectedProviderValue?.data?.id
            ? selectedProviderValue?.data?.id
            : null,
          products: [
            {
              primitive: {
                lengthOfNeed: processedData.orderKeyValues[1].labelValue
                  ? processedData.orderKeyValues[1].labelValue
                  : null,
                diagnosisCodes: [
                  `${
                    processedData.orderKeyValues[2].labelValue
                      ? processedData.orderKeyValues[2].labelValue
                      : ""
                  }`,
                ],
              },
            },
          ],
        },
      },
      referringProvider: {
        salesAgent: selectedProviderValue?.data?.salesAgent
          ? selectedProviderValue?.data?.salesAgent
          : null,
        id: selectedProviderValue?.data?.id
          ? selectedProviderValue?.data?.id
          : null,
        general: {
          name: {
            lastName: processedData.providerKeyValues[1]?.labelValue
              ? processedData.providerKeyValues[1]?.labelValue
              : "",
            firstName: processedData.providerKeyValues[0]?.labelValue
              ? processedData.providerKeyValues[0]?.labelValue
              : "",
            middleName: selectedProviderValue?.data?.general?.name?.middleName
              ? selectedProviderValue?.data?.general?.name?.middleName
              : "",
          },
          Title: selectedProviderValue?.data?.general?.Title
            ? selectedProviderValue?.data?.general?.Title
            : "",
          npi: processedData.providerKeyValues[4]?.labelValue
            ? processedData.providerKeyValues[4]?.labelValue
            : "",
        },
        note: selectedProviderValue?.data?.note
          ? selectedProviderValue?.data?.note
          : null,
        locations: selectedProviderValue?.data?.locations
          ? selectedProviderValue?.data?.locations
          : null,
        primaryLocation:
          providerTypeDropdown == "Existing" &&
          selectedProviderLocation?.data?.id
            ? {
                id: selectedProviderLocation?.data?.id
                  ? selectedProviderLocation?.data?.id
                  : null,
                address: {
                  addressLine:
                    processedData?.providerKeyValues[5]?.labelValue
                      ?.addressLine,
                  city: processedData?.providerKeyValues[5]?.labelValue?.city,
                  state:
                    processedData?.providerKeyValues[5]?.labelValue?.state?.toUpperCase(),
                  zip: processedData?.providerKeyValues[5]?.labelValue?.zip,
                },
                contacts: {
                  phone: processedData.providerKeyValues[2]?.labelValue
                    ? String(
                        processedData.providerKeyValues[2].labelValue,
                      ).replace(/[- )(]/g, "")
                    : "",
                  fax: processedData.providerKeyValues[3]?.labelValue
                    ? String(
                        processedData.providerKeyValues[3].labelValue,
                      ).replace(/[- )(]/g, "")
                    : "",
                },
              }
            : providerTypeDropdown == "New"
            ? {
                id: selectedProviderLocation?.data?.id
                  ? selectedProviderLocation?.data?.id
                  : null,
                address: {
                  addressLine:
                    processedData?.providerKeyValues[5]?.labelValue
                      ?.addressLine,
                  city: processedData?.providerKeyValues[5]?.labelValue?.city,
                  state:
                    processedData?.providerKeyValues[5]?.labelValue?.state?.toUpperCase(),
                  zip: processedData?.providerKeyValues[5]?.labelValue?.zip,
                },
                contacts: {
                  phone: processedData.providerKeyValues[2]?.labelValue
                    ? processedData.providerKeyValues[2]?.labelValue?.replace(
                        /[- )(]/g,
                        "",
                      )
                    : "",
                  fax: processedData.providerKeyValues[3]?.labelValue
                    ? processedData.providerKeyValues[3]?.labelValue?.replace(
                        /[- )(]/g,
                        "",
                      )
                    : null,
                },
              }
            : null,
        contactPerson: selectedProviderValue?.data?.contactPerson
          ? selectedProviderValue?.data?.contactPerson
          : null,
        salesAgentNote: selectedProviderValue?.data?.salesAgentNote
          ? selectedProviderValue?.data?.salesAgentNote
          : null,
        pecosEnrollment: selectedProviderValue?.data?.pecosEnrollment
          ? selectedProviderValue?.data?.pecosEnrollment
          : false,
      },
      coordinatesJson: JSON.stringify(highlightData["coordinates"]),
    };
    return paramsNeed;
  };

  // This is the function for save the current data of process page.
  const saveProcessedData = (e) => {
    let val = "";
    if (e == "create") {
      val = "create";
    } else if (e == "attach") {
      val = "attach";
    } else if (e == "reset") {
      val = "reset";
    }
    let paramsNeed = setParams(val);

    if(!isDemo){
    axiosRequest
      .post(`${process.env.REACT_APP_BaseUrl}save`, paramsNeed)
      .then((res) => {
        if (res.data) {
          setSaveButtonEnable(false);
          if (val == "") {
            setMessage({ msg: res.data, for: "success" });
            setsaveMsgSucessPopup(!saveMsgSucessPopup);
            setResetButtonEnable(true);
            setIsRedirected(false);
          } else {
            setIsRedirected(true);
          }

          setEditable(false);
        }
      })
      .catch((err) => {
        console.log(err, "save=====");
      });

    }else{
      setTimeout(() => {
        if (val == "") {
          setMessage({ msg: "Saved successfully", for: "success" });
          setsaveMsgSucessPopup(!saveMsgSucessPopup);
          setResetButtonEnable(true);
          setIsRedirected(false);
        } else {
          setIsRedirected(true);
        }

        setSaveButtonEnable(false);
        setEditable(false);
      }, 750);
    }
  };

  // This is the function for api call for creating and attaching patient.
  const createAndAttachPatientCall = (e, params) => {
    saveProcessedData(e);
    setLoader("create&AttPatientLoader");

    // Simulate API call with 5 second delay

    if(isDemo){
      setTimeout(() => {
        setLoader("");
        // Simulate successful response
        const mockResponse = {
          data: {
            id: "123", // Mock ID
            general: {
              name: { fullName: "John Doe" },
              dateOfBirth: "1990-01-01T00:00:00",
            },
          },
        };

        // Use the mock response data
        if (mockResponse.data?.id) {
          setMessage({
            msg:
              patientTypeDropdown === "Existing" &&
              providerTypeDropdown === "Existing"
                ? "Document attached successfully"
                : patientTypeDropdown === "New" && providerTypeDropdown === "New"
                ? "Patient and provider created successfully"
                : patientTypeDropdown === "New"
                ? "Patient created and document attached to provider successfully"
                : "Provider created and document attached to patient successfully",
            for: "success",
          });
          setpatientTypeDropdown("Existing");
          setselectedPatientValue({
            name: `${mockResponse.data?.general?.name?.fullName} ${
              mockResponse.data?.general?.dateOfBirth
                ? "(" +
                  formatDate(
                    new Date(
                      mockResponse.data?.general?.dateOfBirth?.includes("T")
                        ? mockResponse.data?.general?.dateOfBirth
                        : mockResponse.data?.general?.dateOfBirth?.replaceAll(
                            "-",
                            "/",
                          ),
                    ),
                  ) +
                  ")"
                : ""
            }`,
            data: mockResponse.data,
          });
        } else if (mockResponse.data) {
          setMessage({ msg: "Document attached successfully", for: "success" });
        }
        setsaveMsgSucessPopup(true);
        setSaveButtonEnable(false);
        closePopup();
      }, 5000); // 5 seconds delay

    }
    else{
      axiosRequest
      .post(`${process.env.REACT_APP_BaseUrl}createpatient`, params)
      .then((res) => {
        setLoader("");
        if (res.data?.id) {
          setMessage({ msg: "Patient created successfully", for: "success" });
          setpatientTypeDropdown("Existing");
          setselectedPatientValue({
            name: `${res.data?.general?.name?.fullName} ${
              res.data?.general?.dateOfBirth
                ? "(" +
                  formatDate(
                    new Date(
                      res.data?.general?.dateOfBirth?.includes("T")
                        ? res.data?.general?.dateOfBirth
                        : res.data?.general?.dateOfBirth?.replaceAll("-", "/")
                    )
                  ) +
                  ")"
                : ""
            }`,
            data: res.data,
          });
        } else if (res.data) {
          setMessage({ msg: "Document attached successfully", for: "success" });
        }
        setsaveMsgSucessPopup(true);
        setSaveButtonEnable(false);
        closePopup();
      })
      .catch((err) => {
        setLoader("");
        if (err?.response?.data?.length < 2) {
          setMessage({ msg: err?.response?.data[0]?.Message, for: "error" });
          setProcessError(true);
        } else {
          setMessage({ msg: err?.response?.data, for: "error" });
          setProcessError(true);
        }
        closePopup();
        setPatientErrorMessage(patientKeys);
      });
    }

    setPatientErrorMessage(patientKeys);
  };

  const dobValidation = (date) => {
    if (date?.includes("-")) {
      let year = date?.split("-")[0];
      let month = date?.split("-")[1];
      let day = date?.split("-")[2];
      if (!(year <= currentyr)) {
        return false;
      } else if (!(month <= currentMonth) && year == currentyr) {
        return false;
      } else if (
        !(day <= currentDay) &&
        month == currentMonth &&
        year == currentyr
      ) {
        return false;
      }
    } else if (date?.includes("/")) {
      let year = date?.split("/")[2];
      let month = date?.split("/")[0];
      let day = date?.split("/")[1];
      if (!(year <= currentyr)) {
        return false;
      } else if (!(month <= currentMonth) && year == currentyr) {
        return false;
      } else if (
        !(day <= currentDay) &&
        month == currentMonth &&
        year == currentyr
      ) {
        return false;
      }
    }
    return true; // Added explicit return for valid dates
  };

  // This is the function attached to the html event to create and attach patient.
  const createPatientAndAttach = (e) => {
    let params = setParams("PatientCreate");
    if (patientTypeDropdown == "New") {
      // Log each condition separately
      console.log("Checking conditions:");
      console.log(
        "1. First Name:",
        processedData?.patientKeyValues[0]?.labelValue,
      );
      console.log(
        "2. Last Name:",
        processedData?.patientKeyValues[1]?.labelValue,
      );
      console.log("3. Gender:", processedData?.patientKeyValues[2]?.labelValue);
      console.log("4. DOB:", processedData?.patientKeyValues[3]?.labelValue);
      console.log(
        "5. Address Line:",
        processedData?.patientKeyValues[5]?.labelValue?.addressLine,
      );
      console.log(
        "6. City:",
        processedData?.patientKeyValues[5]?.labelValue?.city,
      );
      console.log(
        "7. State:",
        processedData?.patientKeyValues[5]?.labelValue?.state,
      );
      console.log(
        "8. Zip:",
        processedData?.patientKeyValues[5]?.labelValue?.zip,
      );
      console.log("9. Phone:", processedData?.patientKeyValues[4]?.labelValue);
      console.log(
        "10. Phone Length:",
        processedData?.patientKeyValues[4]?.labelValue?.length === 14,
      );
      console.log("11. Selected Document:", selectedDocumentValue);
      console.log("12. Patient Type:", patientTypeDropdown);
      console.log(
        "13. State Length:",
        processedData?.patientKeyValues[4]?.labelValue?.state?.length === 2,
      );

      if (
        processedData?.patientKeyValues[0].labelValue &&
        processedData?.patientKeyValues[1].labelValue &&
        processedData?.patientKeyValues[2].labelValue &&
        processedData?.patientKeyValues[3].labelValue &&
        processedData?.patientKeyValues[5]?.labelValue?.addressLine &&
        processedData?.patientKeyValues[5]?.labelValue?.city &&
        processedData?.patientKeyValues[5]?.labelValue?.state &&
        processedData?.patientKeyValues[5]?.labelValue?.zip &&
        processedData?.patientKeyValues[4]?.labelValue &&
        processedData?.patientKeyValues[4]?.labelValue?.length == 14 &&
        selectedDocumentValue &&
        patientTypeDropdown &&
        processedData?.patientKeyValues[5]?.labelValue?.state?.length == 2
      ) {
        createAndAttachPatientCall(e, params);
      } else {
        console.log("Validation failed - closing popup");
        // closePopup();
      }
    } else if (
      patientTypeDropdown == "Existing" &&
      selectedPatientValue?.data?.id
    ) {
      createAndAttachPatientCall(e, params);
    }
  };
  // Chached the pdf @react-pdf-viewer for this library.
  // <ProcessPDFView in this component with pdf will show.
  const cachedValue = useMemo(() => {
    return <ProcessPDFView pdf={uploadedPdf} />;
  }, [uploadedPdf]);

  //Reset button click it will take call the reset api which OCR out put generated.
  // and removed earlier changes.
  const resetOcrResult = () => {
    if (currentPage == "parent") {
      getProcessFax(props?.location?.state?.pdfVal?.Id, "", true);
    } else {
      getProcessFax(
        props?.location?.state?.parent?.Id,
        props?.location?.state?.child?.id,
        true,
      );
    }
  };

  // When reset is called then the pop will not need to load that's the reason, this binds.
  useEffect(() => {
    if (saveType == "reset") {
      saveProcessedData("reset");
      setSaveType("");
    }
  }, [saveType]);

  // Getting the provider location call.
  const getproviderLocation = (providerId) => {
    if (providerId) {
      axiosRequest
        .get(
          `${process.env.REACT_APP_BaseUrl}getreferringproviderlocations/${providerId}`,
        )
        .then((res) => {
          if (res.data?.length > 0) {
            let addressList = [];
            res.data?.forEach((element) => {
              addressList.push({
                name: `${element?.address?.addressLine}, ${element?.address?.city}, ${element?.address?.state}, ${element?.address?.zip}`,
                data: element,
              });
            });
            setLocationProviderDropdown(addressList);
            if (res.data?.length == 1) {
              setselectedProviderLocation(addressList[0]);
              dropDownSelectProviderLocation(addressList[0]);
            }
          }
        })
        .catch((err) => {
          console.log(err, "getreferringproviderlocations=====");
        });
    }
  };

  //Get orderList on basis on id.
  const getOrderList = (id) => {
    axiosRequest
      .get(`${process.env.REACT_APP_BaseUrl}orderlist?id=${id}`)
      .then((res) => {
        let data = res?.data?.content;
        if (data?.length == 1) {
          setselectedOrderValue({
            name: `${data[0]?.displayId}`,
            data: data[0],
          });
        } else {
          setselectedOrderValue({ name: "Order not selected" });
        }
      })
      .catch((err) => {
        console.log(err, "orderlist");
        setselectedOrderValue({ name: "Order not selected" });
      });
  };

  const getOrderSuccessMessage = (patientType, providerType, orderType) => {
    // Count what was newly created
    const newItems = [
      patientType === "New" ? "Patient" : null,
      providerType === "New" ? "Provider" : null,
      orderType === "New" ? "Order" : null,
    ].filter(Boolean);

    if (newItems.length > 1) {
      // Multiple new items created
      return `${newItems.join(", ")} created successfully`;
    } else if (newItems.length === 1) {
      // One new item created + attachment
      return `${newItems[0]} created and document attached successfully`;
    } else {
      // All existing - just attachment
      return "Document successfully attached to order";
    }
  };

  // Creation of order and attach document to the order.
  const createOrderAndAttach = (type) => {
    console.log("creating and attaching order");

    if (
      orderTypeDropdown &&
      PriorityDropdown &&
      (type == "attach" || type == "create")
    ) {
      let params = setParams("OrderCreate");
      setLoader("create&attachOrderLoader");
      saveProcessedData(type);

      // Simulate API call with 5 second delay
      if(isDemo){
        setTimeout(() => {
          setLoader("");

          // Simulate successful response
          const mockResponse = {
            data: getOrderSuccessMessage(
              patientTypeDropdown,
              providerTypeDropdown,
              orderTypeDropdown,
            ),
          };
          if (mockResponse.data) {
            setMessage({ msg: mockResponse.data, for: "success" });
            setsaveMsgSucessPopup(true);
            setSummaryParamsErrorMessage(summaryErrParams);
            setSaveButtonEnable(false);
          }
          closePopup();
        }, 5000); // 5 seconds delay

      }
      else{
        axiosRequest
        .post(`${process.env.REACT_APP_BaseUrl}createorder`, params)
        .then((res) => {
          setLoader("");
          if (res.data) {
            setMessage({ msg: res.data, for: "success" });
            setsaveMsgSucessPopup(true);
            setSummaryParamsErrorMessage(summaryErrParams);
            setSaveButtonEnable(false);
          }
          closePopup();
        })
        .catch((err) => {
          setLoader("");
          setMessage({
            msg: err?.response?.data
              ? err?.response?.data?.length > 2
                ? err?.response?.data
                : err?.response?.data?.length == 1
                  ? err?.response?.data[0]?.Message
                  : "error Occurs"
              : "error Occurs",
            for: "error",
          });
          setProcessError(true);
          closePopup();
        });
      }
    } else {
      closePopup();
    }
  };

  //When user select patient type as new then getprocessfax response is set for patient parameters.
  const setPatientType = (type) => {
    if (type == "New") {
      setselectedPatientValue({
        name: "Patient not selected",
        data: {
          general: {
            name: {
              fullName: "Patient not selected",
            },
          },
        },
      });
      let keyDataTemp = JSON.parse(
        JSON.stringify(processedData["patientKeyValues"]),
      );
      keyDataTemp?.forEach((element) => {
        if (element.labelBindValue == "FirstName") {
          element.labelValue = actualFaxResponseData?.patientMaster?.general
            ?.name?.firstName
            ? actualFaxResponseData?.patientMaster?.general?.name?.firstName
            : "";
          element.labelGreyout = false;
        } else if (element.labelBindValue == "LastName") {
          element.labelValue = actualFaxResponseData?.patientMaster?.general
            ?.name?.lastName
            ? actualFaxResponseData?.patientMaster?.general?.name?.lastName
            : "";
          element.labelGreyout = false;
        } else if (element.labelBindValue == "DateOfBirth") {
          element.labelValue = actualFaxResponseData?.patientMaster?.general
            ?.dateOfBirth
            ? formatDate(
                new Date(
                  actualFaxResponseData?.patientMaster?.general?.dateOfBirth?.includes(
                    "T",
                  )
                    ? actualFaxResponseData?.patientMaster?.general?.dateOfBirth
                    : actualFaxResponseData?.patientMaster?.general?.dateOfBirth?.replaceAll(
                        "-",
                        "/",
                      ),
                ),
              )
            : "";
          element.labelGreyout = false;
        } else if (element.labelBindValue == "Gender") {
          element.labelValue = actualFaxResponseData?.patientMaster?.general
            ?.gender
            ? actualFaxResponseData?.patientMaster?.general?.gender
            : "";
          element.labelGreyout = false;
        } else if (element.labelBindValue == "Contact") {
          let contacts =
            actualFaxResponseData?.patientMaster?.contacts?.contacts?.length > 0
              ? actualFaxResponseData?.patientMaster?.contacts?.contacts
              : "";
          let contactIndex =
            contacts?.length > 0
              ? contacts?.findIndex((el) => {
                  return el?.type == "Home";
                })
              : -1;
          element.labelValue = formatPhoneNumber(
            `${
              contacts &&
              contactIndex !== -1 &&
              contacts[contactIndex]?.value !== null
                ? contacts[contactIndex]?.value
                : ""
            }`,
          );
          element.labelGreyout = false;
        } else if (element.labelBindValue == "Address") {
          let Address = {
            addressLine: actualFaxResponseData?.patientMaster?.addresses
              ?.patient?.addressLine
              ? actualFaxResponseData?.patientMaster?.addresses?.patient
                  ?.addressLine
              : "",
            city: actualFaxResponseData?.patientMaster?.addresses?.patient?.city
              ? actualFaxResponseData?.patientMaster?.addresses?.patient?.city
              : "",
            state: actualFaxResponseData?.patientMaster?.addresses?.patient
              ?.state
              ? actualFaxResponseData?.patientMaster?.addresses?.patient?.state
              : "",
            zip: actualFaxResponseData?.patientMaster?.addresses?.patient?.zip
              ? actualFaxResponseData?.patientMaster?.addresses?.patient?.zip
              : "",
          };
          element.labelValue = Address;
          element.labelGreyout = false;
        }
        return element;
      });
      setProcessedData((prevState) => {
        let processDataTemp = JSON.parse(JSON.stringify(prevState));
        processDataTemp["patientKeyValues"] = keyDataTemp;
        return processDataTemp;
      });
    }
  };

  // When user select the patient from patient list then set the values and get the order list call.
  const dropDownSelectPatient = (childProps) => {
    if (childProps) {
      setselectedPatientValue(childProps);

      // Clear relevant error messages
      setSummaryParamsErrorMessage((prev) => ({
        ...prev,
        selectedPatient: "", // Clear order selection error
        patientType: "", // Clear order type error if needed
      }));

      let keyDataTemp = JSON.parse(
        JSON.stringify(processedData["patientKeyValues"]),
      );
      keyDataTemp?.forEach((element) => {
        if (element.labelBindValue == "FirstName") {
          element.labelValue = childProps.data?.general?.name?.firstName
            ? childProps.data?.general?.name?.firstName
            : "";
          element.labelGreyout = true;
        } else if (element.labelBindValue == "LastName") {
          element.labelValue = childProps.data?.general?.name?.lastName
            ? childProps.data?.general?.name?.lastName
            : "";
          element.labelGreyout = true;
        } else if (element.labelBindValue == "DateOfBirth") {
          element.labelValue = childProps.data?.general?.dateOfBirth
            ? formatDate(
                new Date(
                  childProps.data?.general?.dateOfBirth?.includes("T")
                    ? childProps.data?.general?.dateOfBirth
                    : childProps.data?.general?.dateOfBirth?.replaceAll(
                        "-",
                        "/",
                      ),
                ),
              )
            : "";
          element.labelGreyout = true;
        } else if (element.labelBindValue == "Gender") {
          element.labelValue = childProps.data?.general?.gender
            ? childProps.data?.general?.gender
            : "";
          element.labelGreyout = true;
        } else if (element.labelBindValue == "Contact") {
          let contacts =
            childProps.data?.contacts?.contacts?.length > 0
              ? childProps.data?.contacts?.contacts
              : "";
          let contactIndex =
            contacts?.length > 0
              ? contacts?.findIndex((el) => {
                  return el?.type == "Home";
                })
              : -1;
          element.labelValue = formatPhoneNumber(
            `${
              contacts &&
              contactIndex !== -1 &&
              contacts[contactIndex]?.value !== null
                ? contacts[contactIndex]?.value
                : ""
            }`,
          );
          element.labelGreyout = true;
        } else if (element.labelBindValue == "Address") {
          element.labelValue = childProps.data?.addresses?.patient
            ? childProps.data?.addresses?.patient
            : { addressLine: "", city: "", state: "", zip: "" };
          element.labelGreyout = true;
        }
        return element;
      });
      let processDataTemp = JSON.parse(JSON.stringify(processedData));
      processDataTemp["patientKeyValues"] = keyDataTemp;
      setProcessedData(processDataTemp);
      getOrderList(childProps.data.id);
      setPatientErrorMessage({
        ...patientErrorMessage,
        patientKeyValues: patientKeys["patientKeyValues"],
      });
    }
  };

  //When user select order type as new then enable the edit mode.
  const setOrderType = (type) => {
    if (type == "New") {
      setselectedOrderValue({ name: "Order not selected" });
      let keyDataTemp = JSON.parse(
        JSON.stringify(processedData["orderKeyValues"]),
      );
      keyDataTemp?.forEach((element) => {
        if (element.labelBindValue == "DateWritten") {
          element.labelGreyout = false;
          element.labelHide = false;
        } else if (element.labelBindValue == "LengthOfNeed") {
          element.labelGreyout = false;
          element.labelHide = false;
        } else if (element.labelBindValue == "DiagnosisCode") {
          element.labelGreyout = false;
          element.labelHide = false;
        }
        return element;
      });
      let providerKeyTemp = JSON.parse(
        JSON.stringify(processedData["providerKeyValues"]),
      );
      providerKeyTemp?.forEach((element) => {
        if (element.labelBindValue == "ProviderFirstName") {
          element.labelHide = false;
        } else if (element.labelBindValue == "ProviderLastName") {
          element.labelHide = false;
        } else if (element.labelBindValue == "ProviderPhone") {
          element.labelHide = false;
        } else if (element.labelBindValue == "ProviderFax") {
          element.labelHide = false;
        } else if (element.labelBindValue == "ProviderNPI") {
          element.labelHide = false;
        } else if (element.labelBindValue == "Address") {
          element.labelHide = false;
        }
        return element;
      });
      setProcessedData((prevState) => {
        let processDataTemp = JSON.parse(JSON.stringify(prevState));
        processDataTemp["orderKeyValues"] = keyDataTemp;
        processDataTemp["providerKeyValues"] = providerKeyTemp;
        return processDataTemp;
      });
    } else if (type == "Existing") {
      let orderKeyTemp = JSON.parse(
        JSON.stringify(processedData["orderKeyValues"]),
      );
      orderKeyTemp?.forEach((element) => {
        // Instead of hiding, gray out the fields
        element.labelGreyout = true;
        return element;
      });
      let providerKeyTemp = JSON.parse(
        JSON.stringify(processedData["providerKeyValues"]),
      );
      providerKeyTemp?.forEach((element) => {
        // Instead of hiding, gray out the fields
        element.labelGreyout = true;
        return element;
      });
      setProcessedData((prevState) => {
        let processDataTemp = JSON.parse(JSON.stringify(prevState));
        processDataTemp["providerKeyValues"] = providerKeyTemp;
        processDataTemp["orderKeyValues"] = orderKeyTemp;
        return processDataTemp;
      });
    }
  };

  const dropDownSelectOrder = (childProps) => {
    if (childProps) {
      // Set selected order
      setselectedOrderValue(childProps);

      // Clear relevant error messages
      setSummaryParamsErrorMessage((prev) => ({
        ...prev,
        selectedOrder: "", // Clear order selection error
        orderType: "", // Clear order type error if needed
      }));

      // Update processed data
      let keyDataTemp = JSON.parse(
        JSON.stringify(processedData["orderKeyValues"]),
      );
      keyDataTemp?.forEach((element) => {
        if (element.labelBindValue == "DateWritten") {
          element.labelValue = childProps.data?.dateWritten
            ? childProps.data?.dateWritten
            : "";
          element.labelGreyout = true;
        } else if (element.labelBindValue == "LengthOfNeed") {
          element.labelValue = childProps.data?.lengthOfNeed
            ? childProps.data?.lengthOfNeed
            : 1;
          element.labelGreyout = true;
        } else if (element.labelBindValue == "DiagnosisCode") {
          element.labelValue = childProps.data?.diagnosisCode
            ? childProps.data?.diagnosisCode
            : "";
          element.labelGreyout = true;
        }
        return element;
      });

      let processDataTemp = JSON.parse(JSON.stringify(processedData));
      processDataTemp["orderKeyValues"] = keyDataTemp;
      setProcessedData(processDataTemp);
    }
  };

  //When user select provider type as new then getprocessfax response is set for provider parameters.
  // and when type as existing then grey out for those.
  const setProviderType = (type) => {
    if (type == "New") {
      setselectedProviderValue({ name: "Provider not selected" });
      let keyDataTemp = JSON.parse(
        JSON.stringify(processedData["providerKeyValues"]),
      );
      keyDataTemp?.forEach((element) => {
        if (element.labelBindValue == "ProviderFirstName") {
          element.labelValue = actualFaxResponseData?.referringProvider?.general
            ?.name?.firstName
            ? actualFaxResponseData?.referringProvider?.general?.name?.firstName
            : "";
          element.labelGreyout = false;
        } else if (element.labelBindValue == "ProviderLastName") {
          element.labelValue = actualFaxResponseData?.referringProvider?.general
            ?.name?.lastName
            ? actualFaxResponseData?.referringProvider?.general?.name?.lastName
            : "";
          element.labelGreyout = false;
        } else if (element.labelBindValue == "ProviderPhone") {
          element.labelValue = actualFaxResponseData?.referringProvider
            ?.primaryLocation?.contacts?.phone
            ? formatPhoneNumber(
                actualFaxResponseData?.referringProvider?.primaryLocation
                  ?.contacts?.phone,
              )
            : "";
          element.labelGreyout = false;
        } else if (element.labelBindValue == "ProviderFax") {
          element.labelValue = actualFaxResponseData?.referringProvider
            ?.primaryLocation?.contacts?.fax
            ? formatPhoneNumber(
                actualFaxResponseData?.referringProvider?.primaryLocation
                  ?.contacts?.fax,
              )
            : "";
          element.labelGreyout = false;
        } else if (element.labelBindValue == "ProviderNPI") {
          element.labelValue = actualFaxResponseData?.referringProvider?.general
            ?.npi
            ? actualFaxResponseData?.referringProvider?.general?.npi
            : "";
          element.labelGreyout = false;
        } else if (element.labelBindValue == "Address") {
          element.labelValue = {
            addressLine: "",
            city: "",
            state: "",
            zip: "",
          };
          element.labelGreyout = false;
        }
        return element;
      });
      let processDataTemp = JSON.parse(JSON.stringify(processedData));
      processDataTemp["providerKeyValues"] = keyDataTemp;
      setProcessedData(processDataTemp);
    } else if (type == "Existing") {
      let keyDataTemp = JSON.parse(
        JSON.stringify(processedData["providerKeyValues"]),
      );
      keyDataTemp?.forEach((element) => {
        element.labelGreyout = true;
        return element;
      });
      let processDataTemp = JSON.parse(JSON.stringify(processedData));
      processDataTemp["providerKeyValues"] = keyDataTemp;
      setProcessedData(processDataTemp);
    }
  };

  // When user select the provider from provider list then set the values and grey out.
  const dropDownSelectProvider = (childProps) => {
    if (childProps) {
      setselectedProviderValue(childProps);
      let keyDataTemp = JSON.parse(
        JSON.stringify(processedData["providerKeyValues"]),
      );
      keyDataTemp?.forEach((element) => {
        if (element.labelBindValue == "ProviderFirstName") {
          element.labelValue = childProps.data?.general?.name?.firstName
            ? childProps.data?.general?.name?.firstName
            : "";
          element.labelGreyout = true;
        } else if (element.labelBindValue == "ProviderLastName") {
          element.labelValue = childProps.data?.general?.name?.lastName
            ? childProps.data?.general?.name?.lastName
            : "";
          element.labelGreyout = true;
        } else if (element.labelBindValue == "ProviderPhone") {
          element.labelValue = childProps.data?.primaryLocation?.contacts?.phone
            ? formatPhoneNumber(
                childProps.data?.primaryLocation?.contacts?.phone,
              )
            : "";
          element.labelGreyout = true;
        } else if (element.labelBindValue == "ProviderFax") {
          element.labelValue = childProps.data?.primaryLocation?.contacts?.fax
            ? formatPhoneNumber(childProps.data?.primaryLocation?.contacts?.fax)
            : "";
          element.labelGreyout = true;
        } else if (element.labelBindValue == "ProviderNPI") {
          element.labelValue = childProps.data?.general?.npi
            ? childProps.data?.general?.npi
            : "";
          element.labelGreyout = true;
        } else if (element.labelBindValue == "Address") {
          element.labelValue = {
            addressLine: "",
            city: "",
            state: "",
            zip: "",
          };
          element.labelGreyout = true;
        }
        return element;
      });
      setProcessedData((prevState) => {
        let processDataTemp = JSON.parse(JSON.stringify(prevState));
        processDataTemp["providerKeyValues"] = [...keyDataTemp];
        return processDataTemp;
      });
      getproviderLocation(childProps?.data?.id);
      setselectedProviderLocation({});
      let errmsg = patientErrorMessage["providerKeyValues"];
      errmsg.ProviderNPI = "";
      setPatientErrorMessage({
        ...patientErrorMessage,
        providerKeyValues: errmsg,
      });
    }
  };

  // This is the function for location selected in location list.
  const dropDownSelectProviderLocation = (location) => {
    if (location) {
      let AddressObj = {
        addressLine: location?.data?.address?.addressLine
          ? location?.data?.address?.addressLine
          : "",
        city: location?.data?.address?.city
          ? location?.data?.address?.city
          : "",
        state: location?.data?.address?.state
          ? location?.data?.address?.state
          : "",
        zip: location?.data?.address?.zip ? location?.data?.address?.zip : "",
      };
      let ProviderPhoneObj = location?.data?.contacts?.phone
        ? formatPhoneNumber(location?.data?.contacts?.phone)
        : "";
      let ProviderFaxObj = location.data.contacts.fax
        ? formatPhoneNumber(location.data.contacts.fax)
        : "";
      let keyDataTemp = JSON.parse(
        JSON.stringify(processedData["providerKeyValues"]),
      );
      let errmsg = patientErrorMessage["providerKeyValues"];
      keyDataTemp?.forEach((element, index) => {
        if (element.labelBindValue == "Address") {
          let addressError = {
            addressLine: "",
            city: "",
            state: "",
            zip: "",
          };
          errmsg.Address = addressError;
          element.labelValue = AddressObj;
          element.labelGreyout = true;
        } else if (element.labelBindValue == "ProviderPhone") {
          element.labelValue = ProviderPhoneObj;
          element.labelGreyout = true;
          errmsg.ProviderPhone = "";
        } else if (element.labelBindValue == "ProviderFax") {
          element.labelValue = ProviderFaxObj;
          element.labelGreyout = true;
          errmsg.ProviderFax = "";
        }
        setPatientErrorMessage({
          ...patientErrorMessage,
          providerKeyValues: errmsg,
        });
        return element;
      });
      setProcessedData((prevState) => {
        let processDataTemp = JSON.parse(JSON.stringify(prevState));
        processDataTemp["providerKeyValues"][5] = keyDataTemp[5];
        processDataTemp["providerKeyValues"][3] = keyDataTemp[3];
        processDataTemp["providerKeyValues"][2] = keyDataTemp[2];
        return processDataTemp;
      });
    }
  };

  // This is the function for setting the address for provider from validateNpi function.
  const validNpiData = (data) => {
    if (data) {
      setselectedProviderLocation({
        name: `${data?.primaryLocation?.address?.addressLine},${
          data?.primaryLocation?.address?.addressLine2
            ? data?.primaryLocation?.address?.addressLine2
            : ""
        }, ${data?.primaryLocation?.address?.city}, ${
          data?.primaryLocation?.address?.state
        }, ${data?.primaryLocation?.address?.zip}`,
        data: data,
      });
      let keyDataTemp = JSON.parse(
        JSON.stringify(processedData["providerKeyValues"]),
      );
      keyDataTemp?.forEach((element) => {
        if (element.labelBindValue == "ProviderFirstName") {
          element.labelValue = data?.general?.name?.firstName
            ? data?.general?.name?.firstName
            : "";
          element.labelGreyout = true;
        } else if (element.labelBindValue == "ProviderLastName") {
          element.labelValue = data?.general?.name?.lastName
            ? data?.general?.name?.lastName
            : "";
          element.labelGreyout = true;
        } else if (element.labelBindValue == "ProviderPhone") {
          element.labelValue = data.primaryLocation.contacts.phone
            ? formatPhoneNumber(data.primaryLocation.contacts.phone)
            : "";
          // element.labelValue = processedData.providerKeyValues[2].labelValue ? formatPhoneNumber(processedData.providerKeyValues[2].labelValue) :""
          element.labelGreyout = false;
        } else if (element.labelBindValue == "ProviderFax") {
          // element.labelValue = data.primaryLocation.contacts.fax ? data.primaryLocation.contacts.fax:""
          element.labelValue = processedData.providerKeyValues[3].labelValue
            ? formatPhoneNumber(processedData.providerKeyValues[3].labelValue)
            : "";
          element.labelGreyout = false;
        } else if (element.labelBindValue == "ProviderNPI") {
          element.labelValue = data?.general?.npi ? data?.general?.npi : "";
          element.labelGreyout = false;
        } else if (element.labelBindValue == "Address") {
          element.labelValue = {
            addressLine: `${
              data?.primaryLocation?.address?.addressLine
                ? data?.primaryLocation?.address?.addressLine
                : ""
            } ${
              data?.primaryLocation?.address?.addressLine2
                ? data?.primaryLocation?.address?.addressLine2
                : ""
            }`,
            city: data?.primaryLocation?.address?.city
              ? data?.primaryLocation?.address?.city
              : "",
            state: data?.primaryLocation?.address?.state
              ? data?.primaryLocation?.address?.state
              : "",
            zip: data?.primaryLocation?.address?.zip
              ? data?.primaryLocation?.address?.zip
              : "",
          };
          element.labelGreyout = false;
        }
        return element;
      });
      let processDataTemp = JSON.parse(JSON.stringify(processedData));
      processDataTemp["providerKeyValues"] = keyDataTemp;
      setProcessedData(processDataTemp);
    }
  };

  // When user enter the npi number then this is the function for gave the address.
  const validateNpi = (npiVal) => {
    let validRegx = /^[0-9]{10}$/;
    if (validRegx.test(npiVal)) {
      setLoader("validateNPILoader");
      axiosRequest
        .get(`${process.env.REACT_APP_BaseUrl}validatenpi/${npiVal}`)
        .then((res) => {
          setLoader("");
          if (res.data) {
            validNpiData(res.data);
          }
        })
        .catch((err) => {
          setLoader("");
          if (err?.response?.data?.length > 2) {
            setMessage({ msg: err?.response?.data, for: "error" });
            setProcessError(true);
          } else {
            setMessage({ msg: "NPI doesn't exist.", for: "error" });
            setProcessError(true);
          }
        });
    } else {
      setMessage({ msg: "Please enter valid NPI", for: "error" });
      setProcessError(true);
    }
  };

  //When successful message is came then redirected to the index page.
  const redirectIndexPage = () => {
    history.push({
      pathname: "/home",
      state: { indexPageState: history.location.state.indexPageState },
    });
  };

  // In edit mode dateofbith object getting empty so set the existing date.
  const editExistingDateOnEditButton = (dateVal) => {
    let returnDate = "";
    if (dateVal?.includes("/")) {
      dateVal = dateVal?.split("/");
      returnDate = `${dateVal[2]}-${dateVal[0]}-${dateVal[1]}`;
      return returnDate;
    } else {
      return dateVal;
    }
  };

  // Common validation function
  const validateCommonFields = (errors) => {
    if (!orderTypeDropdown) errors.summary.orderType = "Please Select Value";
    if (!PriorityDropdown) errors.summary.priorityL = "Please Select Value";
    if (!therapyTypeDropdown)
      errors.summary.therapyType = "Please Select Value";
    if (!selectedDocumentValue)
      errors.summary.documentType = "Please Select Value";
  };

  // Common error handling
  const handleErrors = (errors, enableSave = false) => {
    closePopup();
    setEditable(true);
    setSaveButtonEnable(true);
    setSummaryParamsErrorMessage({
      ...summaryParamsErrorMessage,
      ...errors.summary,
    });
    return true;
  };

  // Create patient
  const createPatient = (e) => {
    e.preventDefault();

    const errors = {
      patientKeyValues: {
        FirstName: "",
        LastName: "",
        Gender: "",
        DateOfBirth: "",
        Address: {
          addressLine: "",
          city: "",
          state: "",
          zip: "",
        },
        Contact: "",
      },
      providerKeyValues: {
        ProviderFirstName: "",
        ProviderLastName: "",
        ProviderPhone: "",
        ProviderFax: "",
        ProviderNPI: "",
        Address: {
          addressLine: "",
          city: "",
          state: "",
          zip: "",
        },
      },
      summary: {},
    };

    setPatientErrorMessage((prev) => ({
      ...prev,
      providerKeyValues: {},
    }));

    let docAndPtypeVal = validateDocumentAndPatientType();
    if (docAndPtypeVal === "error") {
      errors.summary = { ...errors.summary, ...summaryParamsErrorMessage };
    }

    validateCommonFields(errors);

    const patientErrors = validatePatientValue();
    if (patientErrors !== "") {
      errors.patientKeyValues = { ...patientErrorMessage.patientKeyValues };
    }

    const hasPatientErrors = patientErrors === "error";
    const hasSummaryErrors = Object.keys(errors.summary).length > 0;
    const hasErrors = hasPatientErrors || hasSummaryErrors;

    if (hasErrors) {
      return handleErrors(errors, true);
    }

    createPatientAndAttach("create");
  };

  // Attach Patient
  const attachPatient = (e) => {
    e.preventDefault();
    const errors = { summary: {} };

    setPatientErrorMessage((prev) => ({
      ...prev,
      providerKeyValues: {},
    }));

    let docAndPtypeVal = validateDocumentAndPatientType();
    if (docAndPtypeVal === "error") {
      errors.summary = { ...errors.summary, ...summaryParamsErrorMessage };
    }

    validateCommonFields(errors);

    if (!selectedPatientValue?.data?.id) {
      errors.summary.selectedPatient = "Please Select Value";
    }

    if (Object.keys(errors.summary).length > 0) {
      return handleErrors(errors);
    }

    // setattachPatientPopup(true);
    createPatientAndAttach("attach");
  };

  // Attack Order
  const attachOrder = (e) => {
    e.preventDefault();
    const errors = { summary: {} };

    let checksVal = commonCheckInCreatAndAttachOrder();
    if (checksVal === "error") {
      errors.summary = { ...errors.summary, ...summaryParamsErrorMessage };
    }

    validateCommonFields(errors);

    if (!selectedOrderValue?.data?.id) {
      errors.summary.selectedOrder = "Please Select Value";
    }

    if (Object.keys(errors.summary).length > 0) {
      return handleErrors(errors);
    }

    // setattachOrderPopup(true);
    createOrderAndAttach("attach");
  };

  // Create Order
  const createOrder = async (e) => {
    e.preventDefault();

    const errors = {
      patientKeyValues: {
        FirstName: "",
        LastName: "",
        Gender: "",
        DateOfBirth: "",
        Address: {
          addressLine: "",
          city: "",
          state: "",
          zip: "",
        },
        Contact: "",
      },
      providerKeyValues: {
        ProviderFirstName: "",
        ProviderLastName: "",
        ProviderPhone: "",
        ProviderFax: "",
        ProviderNPI: "",
        Address: {
          addressLine: "",
          city: "",
          state: "",
          zip: "",
        },
      },
      orderKeyValues: {
        DateWritten: "",
        LengthOfNeed: "",
        DiagnosisCode: "",
      },
      summary: {},
    };

    let docAndPtypeVal = validateDocumentAndPatientType();
    if (docAndPtypeVal === "error") {
      errors.summary = { ...errors.summary, ...summaryParamsErrorMessage };
    }

    if (patientTypeDropdown === "Existing" && !selectedPatientValue?.data?.id) {
      errors.summary.selectedPatient = "Please Select Value";
    }

    validateCommonFields(errors);

    const patientErrors = validatePatientValue();
    if (patientErrors !== "") {
      errors.patientKeyValues = { ...patientErrorMessage.patientKeyValues };
    }

    let providerErrors;
    if (providerTypeDropdown === "New") {
      providerErrors = validateProviderValue();
      if (providerErrors !== "") {
        errors.providerKeyValues = { ...patientErrorMessage.providerKeyValues };
      }
    }

    if (!processedData.orderKeyValues[0].labelValue) {
      errors.orderKeyValues.DateWritten = "Enter Value";
    }

    const hasPatientErrors = patientErrors === "error";
    const hasProviderErrors = providerErrors === "error";
    const hasSummaryErrors = Object.keys(errors.summary).length > 0;
    const hasErrors = hasPatientErrors || hasProviderErrors || hasSummaryErrors;

    if (hasErrors) {
      return handleErrors(errors);
    }

    createOrderAndAttach("create");
    // setcreateAttachOrderPopup(true);
  };

  const validateDocumentAndPatientType = () => {
    let returnVal = "";

    if (!patientTypeDropdown) {
      setSummaryParamsErrorMessage((prev) => ({
        ...prev,
        patientType: "Please Select Value",
      }));
      closePopup();
      returnVal = "error";
    }

    if (!selectedDocumentValue) {
      setSummaryParamsErrorMessage((prev) => ({
        ...prev,
        documentType: "Please Select Value",
      }));
      closePopup();
      returnVal = "error";
    }

    return returnVal;
  };

  const validatePatientValue = () => {
    const errors = {
      FirstName: "",
      LastName: "",
      Gender: "",
      DateOfBirth: "",
      Address: {
        addressLine: "",
        city: "",
        state: "",
        zip: "",
      },
      Contact: "",
    };

    let hasErrors = false;

    // Required fields validation
    if (!processedData?.patientKeyValues[0]?.labelValue) {
      errors.FirstName = "Enter Value";
      hasErrors = true;
    }

    if (!processedData?.patientKeyValues[1]?.labelValue) {
      errors.LastName = "Enter Value";
      hasErrors = true;
    }

    if (!processedData?.patientKeyValues[2]?.labelValue) {
      errors.Gender = "Enter Value";
      hasErrors = true;
    }

    // DOB validation
    const dob = processedData?.patientKeyValues[3]?.labelValue;
    if (!dob) {
      errors.DateOfBirth = "Enter Value";
      hasErrors = true;
    } else if (!dobValidation(dob)) {
      errors.DateOfBirth = "Enter valid value";
      hasErrors = true;
    }

    // Phone validation
    const phone = processedData?.patientKeyValues[4]?.labelValue;
    if (!phone || phone.length < 1) {
      errors.Contact = "Enter Value";
      hasErrors = true;
    } else if (phone.length !== 14 || !/^\(\d{3}\) \d{3}-\d{4}$/.test(phone)) {
      errors.Contact = "Enter Valid Phone No";
      hasErrors = true;
    }

    // Address validation
    const address = processedData?.patientKeyValues[5]?.labelValue;
    if (address) {
      if (!address.addressLine) {
        errors.Address.addressLine = "Enter Value";
        hasErrors = true;
      }

      if (!address.city) {
        errors.Address.city = "Enter Value";
        hasErrors = true;
      }

      if (!address.state) {
        errors.Address.state = "Enter Value";
        hasErrors = true;
      } else if (address.state.trim().length !== 2) {
        errors.Address.state = "Please use 2-letter state code";
        hasErrors = true;
      } else if (!stateCodes.includes(address.state.trim().toUpperCase())) {
        errors.Address.state = "Invalid state code";
        hasErrors = true;
      }

      if (!address.zip) {
        errors.Address.zip = "Enter Value";
        hasErrors = true;
      } else if (!/^\d{5}$/.test(address.zip.trim())) {
        errors.Address.zip = "ZIP must be 5 digits";
        hasErrors = true;
      }
    }

    if (hasErrors) {
      setPatientErrorMessage((prev) => ({
        ...prev,
        patientKeyValues: errors,
      }));
      return "error";
    }

    return "";
  };

  const validateProviderValue = () => {
    const errors = {
      ProviderFirstName: "",
      ProviderLastName: "",
      ProviderPhone: "",
      ProviderFax: "",
      ProviderNPI: "",
      Address: {
        addressLine: "",
        city: "",
        state: "",
        zip: "",
      },
    };

    let hasErrors = false;

    // Provider fields validation
    if (!processedData?.providerKeyValues[0]?.labelValue) {
      errors.ProviderFirstName = "Enter Value";
      hasErrors = true;
    }

    if (!processedData?.providerKeyValues[1]?.labelValue) {
      errors.ProviderLastName = "Enter Value";
      hasErrors = true;
    }

    // Provider phone validation
    const phone = processedData?.providerKeyValues[2]?.labelValue;
    if (!phone || phone.length < 1) {
      errors.ProviderPhone = "Enter Value";
      hasErrors = true;
    } else if (phone.length !== 14 || !/^\(\d{3}\) \d{3}-\d{4}$/.test(phone)) {
      errors.ProviderPhone = "Enter Valid Phone No";
      hasErrors = true;
    }

    // Provider fax validation
    const fax = processedData?.providerKeyValues[3]?.labelValue;
    if (fax && (fax.length !== 14 || !/^\(\d{3}\) \d{3}-\d{4}$/.test(fax))) {
      errors.ProviderFax = "Enter Valid Fax No";
      hasErrors = true;
    }

    // NPI validation
    const npi = processedData?.providerKeyValues[4]?.labelValue;
    if (!npi) {
      errors.ProviderNPI = "Enter Value";
      hasErrors = true;
    } else if (!/^\d{10}$/.test(npi.trim())) {
      errors.ProviderNPI = "NPI must be 10 digits";
      hasErrors = true;
    }

    // Provider address validation
    const address = processedData?.providerKeyValues[5]?.labelValue;
    if (address) {
      if (!address.addressLine) {
        errors.Address.addressLine = "Enter Value";
        hasErrors = true;
      }

      if (!address.city) {
        errors.Address.city = "Enter Value";
        hasErrors = true;
      }

      if (!address.state) {
        errors.Address.state = "Enter Value";
        hasErrors = true;
      } else if (address.state.trim().length !== 2) {
        errors.Address.state = "Please use 2-letter state code";
        hasErrors = true;
      } else if (!stateCodes.includes(address.state.trim().toUpperCase())) {
        errors.Address.state = "Invalid state code";
        hasErrors = true;
      }

      if (!address.zip) {
        errors.Address.zip = "Enter Value";
        hasErrors = true;
      } else if (!/^\d{5}$/.test(address.zip.trim())) {
        errors.Address.zip = "ZIP must be 5 digits";
        hasErrors = true;
      }
    }

    if (hasErrors) {
      setPatientErrorMessage((prev) => ({
        ...prev,
        providerKeyValues: errors,
      }));
      return "error";
    }

    return "";
  };

  const commonCheckInCreatAndAttachOrder = () => {
    let returnVal = "";
    let summERR = summaryParamsErrorMessage;
    let docAndPtypeVal = validateDocumentAndPatientType();
    if (docAndPtypeVal == "error") {
      returnVal = "error";
    }
    if (!orderTypeDropdown) {
      summERR.orderType = "Please Select Value";
      setSummaryParamsErrorMessage({ ...summERR });
      closePopup();
      returnVal = "error";
    }
    if (!PriorityDropdown) {
      summERR.priorityL = "Please Select Value";
      setSummaryParamsErrorMessage({ ...summERR });
      closePopup();
      returnVal = "error";
    }
    if (!selectedDocumentValue) {
      summERR.documentType = `Please Select Value`;
      setSummaryParamsErrorMessage({ ...summERR });
      closePopup();
      returnVal = "error";
    }
    if (patientTypeDropdown == "New") {
      let pval = validatePatientValue();
      if (pval == "error") {
        returnVal = "error";
      }
    }
    if (patientTypeDropdown == "Existing" && !selectedPatientValue?.data?.id) {
      let documentErr = summaryParamsErrorMessage;
      documentErr.selectedPatient = "Please Select Value";
      setSummaryParamsErrorMessage({ ...documentErr });
      returnVal = "error";
    }
    return returnVal;
  };

  useEffect(() => {}, [
    cursorSelectetion,
    cursorSelectetionPhone,
    cursorSelectetionFax,
  ]);

  const [value, setValue] = React.useState("summary");

  const handleChange = (event, newValue) => {
    setValue(newValue);
    console.log("Processed Data: ", processedData);
  };

  const [patientDetailAnchorEl, setPatientDetailAnchorEl] = useState(null);

  useEffect(() => {
    if (selectedProviderValue?.data?.id) {
      getproviderLocation(selectedProviderValue.data.id);
    }
  }, [selectedProviderValue]);

  useEffect(() => {
    // If we have locations and no location is currently selected
    if (locationProviderDropdown?.length > 0) {
      const firstLocation = locationProviderDropdown[0];
      setselectedProviderLocation(firstLocation);
      dropDownSelectProviderLocation(firstLocation);
    }
  }, [
    locationProviderDropdown,
    selectedProviderValue,
    locationProviderDropdown,
  ]); // Dependency on locationProviderDropdown array

  const [_cursorPosition, setCursorPosition] = useState(null);

  // Create a cursor management function
  const handleAddressLineChange = (e, keyName) => {
    const cursorPos = e.target.selectionStart;
    editeValue(e, keyName);
    setCursorPosition(cursorPos);
  };

  function trimId(id) {
    if (id.length <= 16) return id; // Return original if too short
    const first8 = id.substring(0, 8);
    const last8 = id.slice(-8);
    return `${first8}${last8}`.toUpperCase();
  }

  const hasSummaryErrors = useMemo(() => {
    // Debug log to see what errors still exist
    console.log("Current summary errors:", summaryParamsErrorMessage);

    // Check each error field
    const hasErrors = Object.entries(summaryParamsErrorMessage).some(
      ([key, value]) => {
        const hasError = value !== "";
        if (hasError) {
          console.log(`Error found in ${key}:`, value); // This will help us see which field still has an error
        }
        return hasError;
      },
    );

    return hasErrors;
  }, [summaryParamsErrorMessage]);

  const hasDataErrors = () => {
    return Object.values(patientErrorMessage).some((section) =>
      Object.values(section).some((error) =>
        typeof error === "string"
          ? error !== ""
          : Object.values(error).some((e) => e !== ""),
      ),
    );
  };

  const [hoveredFieldKey, setHoveredFieldKey] = useState(null);

  const [numPages, setNumPages] = useState(null);
  const [activePage, setActivePage] = useState(1);
  const [scrollOnPageChange, setScrollOnPageChange] = useState(false);

  function handleThumbnailClick(pageNum) {
    setActivePage(pageNum);
    setScrollOnPageChange(true);
  }

  // In the parent component where you have hoveredFieldKey
  const [pinnedHighlights, setPinnedHighlights] = useState(new Set());

  // Function to toggle a field's pinned state
  const togglePinnedHighlight = (fieldKey) => {
    setPinnedHighlights((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(fieldKey)) {
        newSet.delete(fieldKey);
      } else {
        newSet.add(fieldKey);
      }
      return newSet;
    });
  };

  const attachToOrder = actualFaxResponseData?.attachToOrder === true;

  const ActionButton = ({ onClick, text, isVisible }) => (
    <div
      style={{
        transition: "all 300ms ease-out",
        transform: isVisible ? "translateY(0)" : "translateY(20px)",
        opacity: isVisible ? 1 : 0,
      }}
    >
      <Button
        variant="contained"
        onClick={onClick}
        sx={{
          backgroundColor: "#00AB4E",
          "&:hover": {
            backgroundColor: "#008C40",
          },
        }}
      >
        {text}
      </Button>
    </div>
  );

  return (
    <>
      {cookies?.firstName ? (
        <div>
          <Navbar />
          <Container
            className="processview"
            maxWidth="2xl"
            sx={{ py: 3, pb: 4, backgroundColor: "#FaFaFa" }}
            style={{
              paddingRight: "2.5rem",
              paddingLeft: "2.5rem",
            }}
          >
            {/* Navigation Links + Action Buttons */}
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Stack direction="column" spacing={0.2}>
                <Typography
                  to="/"
                  sx={{
                    textDecoration: "none",
                  }}
                  className="darkText"
                >
                  Fax ID: {trimId(actualFaxResponseData.faxId ?? "")}
                </Typography>
                <Typography
                  to="/order-list"
                  sx={{
                    textDecoration: "none",
                    fontSize: "0.875rem",
                    color: "#9499A1",
                  }}
                >
                  <Link
                    to={{
                      pathname: "/home",
                      state: {
                        indexPageState: history.location.state.indexPageState,
                      },
                    }}
                    style={{ color: "#01ab4f" }}
                  >
                    Home
                  </Link>
                  {">"} Fax Document
                </Typography>
              </Stack>

              {/* Dialogs */}
              <Stack
                sx={{
                  height: "fit-content",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
                direction={"row"}
                spacing={3}
              >
                {!attachToOrder ? (
                  // Patient flow
                  <>
                    {actualFaxResponseData?.contextSetting && (
                      <ElsaContent
                        content={actualFaxResponseData.contextSetting}
                      >
                        <ActionButton
                          onClick={(e) =>
                            patientTypeDropdown === "New"
                              ? createPatient(e)
                              : attachPatient(e)
                          }
                          text={"Next"}
                        />
                      </ElsaContent>
                    )}

                    {patientTypeDropdown === "New" ? (
                      <PatientDialog
                        createPatient={createPatient}
                        createAttachPatientPopup={createAttachPatientPopup}
                        closePopup={closePopup}
                        selectedProviderValue={selectedProviderValue}
                        currentPage={currentPage}
                        moveFaxToTrash={moveFaxToTrash}
                        setMoveFaxToTrash={setMoveFaxToTrash}
                        moveChildFaxToTrash={moveChildFaxToTrash}
                        setMoveChildFaxToTrash={setMoveChildFaxToTrash}
                        isLastChild={isLastChild}
                        createPatientAndAttach={createPatientAndAttach}
                        loader={loader}
                      />
                    ) : (
                      <AttachPatientDialog
                        attachPatient={attachPatient}
                        attachPatientPopup={attachPatientPopup}
                        closePopup={closePopup}
                        processedData={processedData}
                        currentPage={currentPage}
                        moveFaxToTrash={moveFaxToTrash}
                        setMoveFaxToTrash={setMoveFaxToTrash}
                        moveChildFaxToTrash={moveChildFaxToTrash}
                        setMoveChildFaxToTrash={setMoveChildFaxToTrash}
                        isLastChild={isLastChild}
                        createPatientAndAttach={createPatientAndAttach}
                        loader={loader}
                      />
                    )}
                  </>
                ) : (
                  // Order flow
                  <>
                    {actualFaxResponseData?.contextSetting && (
                      <ElsaContent
                        content={actualFaxResponseData.contextSetting}
                      >
                        <ActionButton
                          onClick={(e) =>
                            orderTypeDropdown === "New"
                              ? createOrder(e)
                              : attachOrder(e)
                          }
                          text={"Next"}
                        />
                      </ElsaContent>
                    )}

                    {orderTypeDropdown === "New" ? (
                      <CreateOrderDialog
                        createOrder={createOrder}
                        createAttachOrderPopup={createAttachOrderPopup}
                        closePopup={closePopup}
                        patientTypeDropdown={patientTypeDropdown}
                        providerTypeDropdown={providerTypeDropdown}
                        selectedPatientValue={selectedPatientValue}
                        selectedProviderValue={selectedProviderValue}
                        currentPage={currentPage}
                        moveFaxToTrash={moveFaxToTrash}
                        setMoveFaxToTrash={setMoveFaxToTrash}
                        moveChildFaxToTrash={moveChildFaxToTrash}
                        setMoveChildFaxToTrash={setMoveChildFaxToTrash}
                        isLastChild={isLastChild}
                        createOrderAndAttach={createOrderAndAttach}
                        loader={loader}
                      />
                    ) : (
                      <AttachOrderDialog
                        attachOrder={attachOrder}
                        attachOrderPopup={attachOrderPopup}
                        closePopup={closePopup}
                        selectedPatientValue={selectedPatientValue}
                        selectedOrderValue={selectedOrderValue}
                        currentPage={currentPage}
                        moveFaxToTrash={moveFaxToTrash}
                        setMoveFaxToTrash={setMoveFaxToTrash}
                        moveChildFaxToTrash={moveChildFaxToTrash}
                        setMoveChildFaxToTrash={setMoveChildFaxToTrash}
                        isLastChild={isLastChild}
                        createOrderAndAttach={createOrderAndAttach}
                        loader={loader}
                      />
                    )}
                  </>
                )}
              </Stack>
            </Stack>

            {/* Document Loading Indicator */}
            {loader == "processFaxLoader" && (
              <CommanSpinner
                spinner={loader}
                text={
                  (currentPage == "parent" &&
                    props?.location?.state?.pdfVal?.Status == "Processing") ||
                  props?.location?.state?.parent?.Status == "Processing" ||
                  props?.location?.state?.pdfVal?.Status == "Completed" ||
                  props?.location?.state?.parent?.Status == "Completed"
                    ? ""
                    : "Intelligent Intake Processing..."
                }
              />
            )}

            {/* Thumbnails, Pdf and Summary + Data */}
            <Stack direction={"row"} spacing={2} marginTop={3}>
              {uploadedPdf && (
                <div
                  style={{
                    borderTop: "1px solid #ccc",
                    padding: "12px",
                    backgroundColor: "white",
                    backgroundColor: "white",
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 5px",
                    borderRadius: "10px",
                  }}
                >
                  <Document
                    file={uploadedPdf}
                    onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                  >
                    {Array.from(new Array(numPages || 0), (el, index) => (
                      <div
                        key={`thumb-${index}`}
                        style={{
                          cursor: "pointer",
                          marginBottom: "1rem",
                          border: "1px solid #b2adad",
                          borderRadius: "10px",
                          padding: "4px",
                        }}
                        onClick={() => handleThumbnailClick(index + 1)}
                      >
                        <Page
                          pageNumber={index + 1}
                          width={125}
                          renderAnnotationLayer={false}
                          renderTextLayer={false}
                        />
                      </div>
                    ))}
                  </Document>
                </div>
              )}

              {/* PDF VIEW */}
              {uploadedPdf && highlightData && (
                <Box
                  sx={{
                    backgroundColor: "white",
                    padding: "0px 12px",
                    backgroundColor: "white",
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 5px",
                    borderRadius: "10px",
                  }}
                >
                  <PdfHighlighterPanZoom
                    pdfBlob={uploadedPdf}
                    extractedData={highlightData}
                    hoveredFieldKey={hoveredFieldKey}
                    pinnedHighlights={pinnedHighlights}
                    containerWidth={800}
                    containerHeight={1000}
                    activePage={activePage}
                    scrollOnPageChange={scrollOnPageChange}
                    onScrolled={() => setScrollOnPageChange(false)}
                    pdf={props?.location?.state?.pdfVal}
                  />
                </Box>
              )}

              {/* SUMMARY AND DATA */}
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "white",
                  boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 5px",
                  borderRadius: "10px",
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  sx={{
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#00AB4E",
                    },
                    "& .Mui-selected": {
                      color: "#00AB4E !important",
                    },
                    "& .MuiTab-root": {
                      color: "rgba(0, 0, 0, 0.6)",
                    },
                    backgroundColor: "white",
                    borderRadius: "10px",
                    marginBottom: "11px",
                  }}
                >
                  <Tab
                    value="summary"
                    label={
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        Summary
                        {hasSummaryErrors && (
                          <Box
                            sx={{
                              width: 8,
                              height: 8,
                              borderRadius: "50%",
                              backgroundColor: "error.main",
                            }}
                          />
                        )}
                      </Box>
                    }
                  />
                  <Tab
                    value="data"
                    label={
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        Data
                        {hasDataErrors() && (
                          <Box
                            sx={{
                              width: 8,
                              height: 8,
                              borderRadius: "50%",
                              backgroundColor: "error.main",
                            }}
                          />
                        )}
                      </Box>
                    }
                  />
                </Tabs>

                {/* Tab Content Container */}
                <Box
                  sx={{
                    width: "100%",
                    px: 3,
                    pb: 2,
                    overflow: "scroll",
                    "& > *": {
                      maxWidth: "100%",
                    },
                  }}
                >
                  {/* Summary Tab Content */}
                  {value === "summary" && (
                    <Stack direction="column" spacing={4} pt={2}>
                      <TypeSelectionSection
                        patientTypeDropdown={patientTypeDropdown}
                        orderTypeDropdown={orderTypeDropdown}
                        setPatientType={setPatientType}
                        setpatientTypeDropdown={setpatientTypeDropdown}
                        setOrderType={setOrderType}
                        setorderTypeDropdown={setorderTypeDropdown}
                        summaryParamsErrorMessage={summaryParamsErrorMessage}
                        setSummaryParamsErrorMessage={
                          setSummaryParamsErrorMessage
                        }
                      />

                      <PatientDetailsSection
                        patientTypeDropdown={patientTypeDropdown}
                        selectedPatientValue={selectedPatientValue}
                        summaryParamsErrorMessage={summaryParamsErrorMessage}
                        patientDetailAnchorEl={patientDetailAnchorEl}
                        setPatientDetailAnchorEl={setPatientDetailAnchorEl}
                        dropDownSelectPatient={dropDownSelectPatient}
                      />

                      <OrderDetailsSection
                        orderTypeDropdown={orderTypeDropdown}
                        selectedOrderValue={selectedOrderValue}
                        summaryParamsErrorMessage={summaryParamsErrorMessage}
                        selectedDocumentValue={selectedDocumentValue}
                        setselectedDocumentValue={setselectedDocumentValue}
                        setSummaryParamsErrorMessage={
                          setSummaryParamsErrorMessage
                        }
                        documentTypeDropdownList={documentTypeDropdownList}
                        dropDownSelectOrder={dropDownSelectOrder}
                        selectedPatientValue={selectedPatientValue}
                        therapyTypeDropdown={therapyTypeDropdown}
                        settherapyTypeDropdown={settherapyTypeDropdown}
                        therapyTypeDropdownList={therapyTypeDropdownList}
                        PriorityDropdown={PriorityDropdown}
                        setPriorityDropdown={setPriorityDropdown}
                      />

                      <ProviderDetailsSection
                        orderTypeDropdown={orderTypeDropdown}
                        providerTypeDropdown={providerTypeDropdown}
                        summaryParamsErrorMessage={summaryParamsErrorMessage}
                        setProviderType={setProviderType}
                        setproviderTypeDropdown={setproviderTypeDropdown}
                        setselectedProviderLocation={
                          setselectedProviderLocation
                        }
                        setSummaryParamsErrorMessage={
                          setSummaryParamsErrorMessage
                        }
                        selectedProviderValue={selectedProviderValue}
                        dropDownSelectProvider={dropDownSelectProvider}
                        locationProviderDropdown={locationProviderDropdown}
                        selectedProviderLocation={selectedProviderLocation}
                        dropDownSelectProviderLocation={
                          dropDownSelectProviderLocation
                        }
                        getproviderLocation={getproviderLocation}
                      />
                    </Stack>
                  )}

                  {/* Data Tab Content */}
                  {value === "data" && (
                    <Box sx={{}}>
                      <Stack spacing={2}>
                        {/* Edit/Save Buttons */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          {/* <>
                            {(
                              <PDFSplitter
                                uploadedPdf={uploadedPdf}
                                totalPages={props.pdfTotalPages}
                                existingChildPages={props.chaildPdfPage}
                                onSplitComplete={() => {
                                  history.push({
                                    pathname: "/home",
                                    state: {
                                      indexPageState: history?.location?.state?.indexPageState
                                        ? history?.location?.state?.indexPageState
                                        : { alias: [], searchCallerId: "", pageNumber: 1 },
                                    },
                                  });
                                }}
                                onSplitError={(error) => {
                                  console.error('Split error:', error);
                                }}
                                uploadEndpoint={`${process.env.REACT_APP_BaseUrl}splitpdf`}
                                documentId={props?.pdfObject?.pdfVal?.Id}
                              />
                            )}
                          </> */}

                          <Button
                            size="small"
                            variant={editable ? "contained" : "text"}
                            onClick={editButtonClick}
                            endIcon={<EditIcon sx={{ fontSize: "1.2rem" }} />}
                            sx={{
                              color: editable
                                ? "#00AB4E"
                                : "rgba(0, 0, 0, 0.54)",
                              backgroundColor: editable
                                ? "rgba(72, 73, 232, 0.04)"
                                : "transparent",
                              "&:hover": {
                                backgroundColor: "rgba(72, 73, 232, 0.08)",
                              },
                              padding: "8px",
                            }}
                          >
                            Edit
                          </Button>

                          {saveButtonEnable && (
                            <Button
                              size="small"
                              variant="contained"
                              onClick={() => saveProcessedData("")}
                              endIcon={<SaveIcon sx={{ fontSize: "1.2rem" }} />}
                              sx={{
                                ml: 1,
                                color: "#00AB4E",
                                backgroundColor: "transparent",
                                boxShadow: "none",
                                "&:hover": {
                                  backgroundColor: "rgba(72, 73, 232, 0.08)",
                                  boxShadow: "none",
                                },
                                "&.Mui-disabled": {
                                  color: "rgba(0, 0, 0, 0.26)",
                                },
                                padding: "8px",
                              }}
                            >
                              Save
                            </Button>
                          )}
                        </Box>

                        {/* Form Fields */}
                        <Box sx={{ width: "100%", overflow: "hidden" }}>
                          <FormFields
                            editable={editable}
                            processedData={processedData}
                            patientErrorMessage={patientErrorMessage}
                            editeValue={editeValue}
                            handleAddressLineChange={handleAddressLineChange}
                            orderTypeDropdown={orderTypeDropdown}
                            setHoveredFieldKey={setHoveredFieldKey}
                            highlightData={highlightData}
                            pinnedHighlights={pinnedHighlights}
                            togglePinnedHighlight={togglePinnedHighlight}
                          />
                        </Box>
                      </Stack>

                      {loader === "validateNPILoader" && (
                        <CommanSpinner spinner={loader} text="" />
                      )}
                    </Box>
                  )}
                </Box>
              </Box>
            </Stack>

            {/* Replace your existing loader spinners and popups with: */}
            {(loader === "create&attachOrderLoader" ||
              loader === "create&AttPatientLoader" ||
              processError ||
              saveMsgSucessPopup) && (
              <LoadingSuccessErrorDialog
                isLoading={
                  loader === "create&attachOrderLoader" ||
                  loader === "create&AttPatientLoader"
                }
                loadingText={getLoadingText(
                  loader,
                  patientTypeDropdown,
                  providerTypeDropdown,
                  orderTypeDropdown,
                )}
                message={message}
                closeSuccessErrorMsg={() => {
                  if (processError) {
                    setProcessError(false);
                  } else if (saveMsgSucessPopup) {
                    setsaveMsgSucessPopup(false);
                    if (isRedirected) redirectIndexPage();
                  }
                }}
              />
            )}
          </Container>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default ProcessComponent;
